var items = {
  "block.minecraft.acacia_button": "Langil na Pindutan",
  "block.minecraft.acacia_door": "Langil na Pinto",
  "block.minecraft.acacia_fence": "Langil na Bakod",
  "block.minecraft.acacia_fence_gate": "Langil na Tarangkahan",
  "block.minecraft.acacia_hanging_sign": "Langil na Karatulang Nakasabit",
  "block.minecraft.acacia_leaves": "Dahon ng Langil",
  "block.minecraft.acacia_log": "Langil na Troso",
  "block.minecraft.acacia_planks": "Langil na Tabla",
  "block.minecraft.acacia_pressure_plate": "Langil Apakan",
  "block.minecraft.acacia_sapling": "Punla ng Langil",
  "block.minecraft.acacia_shelf": "Langil na Salansanan",
  "block.minecraft.acacia_sign": "Langil na Karatula",
  "block.minecraft.acacia_slab": "Langil na Dalig",
  "block.minecraft.acacia_stairs": "Langil na Hagdanan",
  "block.minecraft.acacia_trapdoor": "Langil na Bukasan",
  "block.minecraft.acacia_wall_hanging_sign": "Langil na Karatulang Nakasabit sa Pader",
  "block.minecraft.acacia_wall_sign": "Langil na Karatula sa Pader",
  "block.minecraft.acacia_wood": "Langil na Kahoy",
  "block.minecraft.activator_rail": "Pansiglang Daang-bakal",
  "block.minecraft.air": "Hangin",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloke ng Amatista",
  "block.minecraft.amethyst_cluster": "Kumpol ng Amatista",
  "block.minecraft.ancient_debris": "Sinaunang Yagit",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Andesitang Dalig",
  "block.minecraft.andesite_stairs": "Andesitang Hagdanan",
  "block.minecraft.andesite_wall": "Andesitang Pader",
  "block.minecraft.anvil": "Palihan",
  "block.minecraft.attached_melon_stem": "Nakakabit na Tangkay ng Pakwan",
  "block.minecraft.attached_pumpkin_stem": "Nakakabit na Tangkay ng Kandos",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Dahon ng Asalea",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Kawayan",
  "block.minecraft.bamboo_block": "Bloke ng Kawayan",
  "block.minecraft.bamboo_button": "Kawayang Pindutan",
  "block.minecraft.bamboo_door": "Kawayang Pinto",
  "block.minecraft.bamboo_fence": "Kawayang Bakod",
  "block.minecraft.bamboo_fence_gate": "Kawayang Tarangkahan",
  "block.minecraft.bamboo_hanging_sign": "Kawayang Karatulang Nakasabit",
  "block.minecraft.bamboo_mosaic": "Sawali",
  "block.minecraft.bamboo_mosaic_slab": "Sawaling Dalig",
  "block.minecraft.bamboo_mosaic_stairs": "Sawaling Hagdanan",
  "block.minecraft.bamboo_planks": "Kawayang Tabla",
  "block.minecraft.bamboo_pressure_plate": "Kawayang Apakan",
  "block.minecraft.bamboo_sapling": "Labong",
  "block.minecraft.bamboo_shelf": "Kawayang Salansanan",
  "block.minecraft.bamboo_sign": "Kawayang Karatula",
  "block.minecraft.bamboo_slab": "Kawayang Dalig",
  "block.minecraft.bamboo_stairs": "Kawayang Hagdanan",
  "block.minecraft.bamboo_trapdoor": "Kawayang Bukasan",
  "block.minecraft.bamboo_wall_hanging_sign": "Kawayang Karatulang Nakasabit sa Pader",
  "block.minecraft.bamboo_wall_sign": "Kawayang Karatula sa Pader",
  "block.minecraft.banner.base.black": "Itim na Saligan",
  "block.minecraft.banner.base.blue": "Bughaw na Saligan",
  "block.minecraft.banner.base.brown": "Kayumangging Saligan",
  "block.minecraft.banner.base.cyan": "Cyan na Saligan",
  "block.minecraft.banner.base.gray": "Abong Saligan",
  "block.minecraft.banner.base.green": "Lungtiang Saligan",
  "block.minecraft.banner.base.light_blue": "Langit na Saligan",
  "block.minecraft.banner.base.light_gray": "Pilak na Saligan",
  "block.minecraft.banner.base.lime": "Dayap na Saligan",
  "block.minecraft.banner.base.magenta": "Mahentang Saligan",
  "block.minecraft.banner.base.orange": "Bulantubig na Saligan",
  "block.minecraft.banner.base.pink": "Kalimbahing Saligan",
  "block.minecraft.banner.base.purple": "Habang Saligan",
  "block.minecraft.banner.base.red": "Pulang Saligan",
  "block.minecraft.banner.base.white": "Puting Saligan",
  "block.minecraft.banner.base.yellow": "Dilaw na Saligan",
  "block.minecraft.banner.border.black": "Itim na Libot",
  "block.minecraft.banner.border.blue": "Bughaw na Libot",
  "block.minecraft.banner.border.brown": "Kayumangging Libot",
  "block.minecraft.banner.border.cyan": "Cyan na Libot",
  "block.minecraft.banner.border.gray": "Abong Libot",
  "block.minecraft.banner.border.green": "Lungtiang Libot",
  "block.minecraft.banner.border.light_blue": "Langit na Libot",
  "block.minecraft.banner.border.light_gray": "Pilak na Libot",
  "block.minecraft.banner.border.lime": "Dayap na Libot",
  "block.minecraft.banner.border.magenta": "Mahentang Libot",
  "block.minecraft.banner.border.orange": "Bulantubig na Libot",
  "block.minecraft.banner.border.pink": "Kalimbahing Libot",
  "block.minecraft.banner.border.purple": "Habang Libot",
  "block.minecraft.banner.border.red": "Pulang Libot",
  "block.minecraft.banner.border.white": "Puting Libot",
  "block.minecraft.banner.border.yellow": "Dilaw na Libot",
  "block.minecraft.banner.bricks.black": "Itim na Saligang Masonado",
  "block.minecraft.banner.bricks.blue": "Bughaw na Saligang Masonado",
  "block.minecraft.banner.bricks.brown": "Kayumangging Saligang Masonado",
  "block.minecraft.banner.bricks.cyan": "Cyan na Saligang Masonado",
  "block.minecraft.banner.bricks.gray": "Abong Saligang Masonado",
  "block.minecraft.banner.bricks.green": "Lungtiang Saligang Masonado",
  "block.minecraft.banner.bricks.light_blue": "Langit na Saligang Masonado",
  "block.minecraft.banner.bricks.light_gray": "Pilak na Saligang Masonado",
  "block.minecraft.banner.bricks.lime": "Dayap na Saligang Masonado",
  "block.minecraft.banner.bricks.magenta": "Mahentang Saligang Masonado",
  "block.minecraft.banner.bricks.orange": "Bulantubig na Saligang Masonado",
  "block.minecraft.banner.bricks.pink": "Kalimbahing Saligang Masonado",
  "block.minecraft.banner.bricks.purple": "Habang Saligang Masonado",
  "block.minecraft.banner.bricks.red": "Pulang Saligang Masonado",
  "block.minecraft.banner.bricks.white": "Puting Saligang Masonado",
  "block.minecraft.banner.bricks.yellow": "Dilaw na Saligang Masonado",
  "block.minecraft.banner.circle.black": "Itim na Redondel",
  "block.minecraft.banner.circle.blue": "Bughaw na Redondel",
  "block.minecraft.banner.circle.brown": "Kayumangging Redondel",
  "block.minecraft.banner.circle.cyan": "Cyan na Redondel",
  "block.minecraft.banner.circle.gray": "Abong Redondel",
  "block.minecraft.banner.circle.green": "Lungtiang Redondel",
  "block.minecraft.banner.circle.light_blue": "Langit na Redondel",
  "block.minecraft.banner.circle.light_gray": "Pilak na Redondel",
  "block.minecraft.banner.circle.lime": "Dayap na Redondel",
  "block.minecraft.banner.circle.magenta": "Mahentang Redondel",
  "block.minecraft.banner.circle.orange": "Bulantubig na Redondel",
  "block.minecraft.banner.circle.pink": "Kalimbahing Redondel",
  "block.minecraft.banner.circle.purple": "Habang Redondel",
  "block.minecraft.banner.circle.red": "Pulang Redondel",
  "block.minecraft.banner.circle.white": "Puting Redondel",
  "block.minecraft.banner.circle.yellow": "Dilaw na Redondel",
  "block.minecraft.banner.creeper.black": "Itim na Selyo ng Creeper",
  "block.minecraft.banner.creeper.blue": "Bughaw na Selyo ng Creeper",
  "block.minecraft.banner.creeper.brown": "Kayumangging Selyo ng Creeper",
  "block.minecraft.banner.creeper.cyan": "Cyan na Selyo ng Creeper",
  "block.minecraft.banner.creeper.gray": "Abong Selyo ng Creeper",
  "block.minecraft.banner.creeper.green": "Lungtiang Selyo ng Creeper",
  "block.minecraft.banner.creeper.light_blue": "Langit na Selyo ng Creeper",
  "block.minecraft.banner.creeper.light_gray": "Pilak na Selyo ng Creeper",
  "block.minecraft.banner.creeper.lime": "Dayap na Selyo ng Creeper",
  "block.minecraft.banner.creeper.magenta": "Mahentang Selyo ng Creeper",
  "block.minecraft.banner.creeper.orange": "Bulantubig na Selyo ng Creeper",
  "block.minecraft.banner.creeper.pink": "Kalimbahing Selyo ng Creeper",
  "block.minecraft.banner.creeper.purple": "Habang Tatak ng Creeper",
  "block.minecraft.banner.creeper.red": "Pulang Selyo ng Creeper",
  "block.minecraft.banner.creeper.white": "Puting Selyo ng Creeper",
  "block.minecraft.banner.creeper.yellow": "Dilaw na Selyo ng Creeper",
  "block.minecraft.banner.cross.black": "Itim na Banal",
  "block.minecraft.banner.cross.blue": "Bughaw na Banal",
  "block.minecraft.banner.cross.brown": "Kayumangging Banal",
  "block.minecraft.banner.cross.cyan": "Cyan na Banal",
  "block.minecraft.banner.cross.gray": "Abong Banal",
  "block.minecraft.banner.cross.green": "Lungtiang Banal",
  "block.minecraft.banner.cross.light_blue": "Langit na Banal",
  "block.minecraft.banner.cross.light_gray": "Pilak na Banal",
  "block.minecraft.banner.cross.lime": "Dayap na Banal",
  "block.minecraft.banner.cross.magenta": "Mahentang Banal",
  "block.minecraft.banner.cross.orange": "Bulantubig na Banal",
  "block.minecraft.banner.cross.pink": "Kalimbahing Banal",
  "block.minecraft.banner.cross.purple": "Habang Banal",
  "block.minecraft.banner.cross.red": "Pulang Banal",
  "block.minecraft.banner.cross.white": "Puting Banal",
  "block.minecraft.banner.cross.yellow": "Dilaw na Banal",
  "block.minecraft.banner.curly_border.black": "Itim na Yuping Libot",
  "block.minecraft.banner.curly_border.blue": "Bughaw na Yuping Libot",
  "block.minecraft.banner.curly_border.brown": "Kayumangging Yuping Libot",
  "block.minecraft.banner.curly_border.cyan": "Cyan na Yuping Libot",
  "block.minecraft.banner.curly_border.gray": "Abong Yuping Libot",
  "block.minecraft.banner.curly_border.green": "Lungtiang Yuping Libot",
  "block.minecraft.banner.curly_border.light_blue": "Langit na Yuping Libot",
  "block.minecraft.banner.curly_border.light_gray": "Pilak na Yuping Libot",
  "block.minecraft.banner.curly_border.lime": "Dayap na Yuping Libot",
  "block.minecraft.banner.curly_border.magenta": "Mahentang Yuping Libot",
  "block.minecraft.banner.curly_border.orange": "Bulantubig na Yuping Libot",
  "block.minecraft.banner.curly_border.pink": "Kalimbahing Yuping Libot",
  "block.minecraft.banner.curly_border.purple": "Habang Yuping Libot",
  "block.minecraft.banner.curly_border.red": "Pulang Yuping Libot",
  "block.minecraft.banner.curly_border.white": "Puting Yuping Libot",
  "block.minecraft.banner.curly_border.yellow": "Dilaw na Yuping Libot",
  "block.minecraft.banner.diagonal_left.black": "Itim na Hiwa",
  "block.minecraft.banner.diagonal_left.blue": "Bughaw na Hiwa",
  "block.minecraft.banner.diagonal_left.brown": "Kayumangging Hiwa",
  "block.minecraft.banner.diagonal_left.cyan": "Cyan na Hiwa",
  "block.minecraft.banner.diagonal_left.gray": "Abong Hiwa",
  "block.minecraft.banner.diagonal_left.green": "Lungtiang Hiwa",
  "block.minecraft.banner.diagonal_left.light_blue": "Langit na Hiwa",
  "block.minecraft.banner.diagonal_left.light_gray": "Pilak na Hiwa",
  "block.minecraft.banner.diagonal_left.lime": "Dayap na Hiwa",
  "block.minecraft.banner.diagonal_left.magenta": "Mahentang Hiwa",
  "block.minecraft.banner.diagonal_left.orange": "Bulantubig na Hiwa",
  "block.minecraft.banner.diagonal_left.pink": "Kalimbahing Hiwa",
  "block.minecraft.banner.diagonal_left.purple": "Habang Hiwa",
  "block.minecraft.banner.diagonal_left.red": "Pulang Hiwa",
  "block.minecraft.banner.diagonal_left.white": "Puting Hiwa",
  "block.minecraft.banner.diagonal_left.yellow": "Dilaw na Hiwa",
  "block.minecraft.banner.diagonal_right.black": "Itim na Putol",
  "block.minecraft.banner.diagonal_right.blue": "Bughaw na Putol",
  "block.minecraft.banner.diagonal_right.brown": "Kayumangging Putol",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan na Putol",
  "block.minecraft.banner.diagonal_right.gray": "Abong Putol",
  "block.minecraft.banner.diagonal_right.green": "Lungtiang Putol",
  "block.minecraft.banner.diagonal_right.light_blue": "Langit na Putol",
  "block.minecraft.banner.diagonal_right.light_gray": "Pilak na Putol",
  "block.minecraft.banner.diagonal_right.lime": "Dayap na Putol",
  "block.minecraft.banner.diagonal_right.magenta": "Mahentang Putol",
  "block.minecraft.banner.diagonal_right.orange": "Bulantubig na Putol",
  "block.minecraft.banner.diagonal_right.pink": "Kalimbahing Putol",
  "block.minecraft.banner.diagonal_right.purple": "Habang Putol",
  "block.minecraft.banner.diagonal_right.red": "Pulang Putol",
  "block.minecraft.banner.diagonal_right.white": "Puting Putol",
  "block.minecraft.banner.diagonal_right.yellow": "Dilaw na Putol",
  "block.minecraft.banner.diagonal_up_left.black": "Itim na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.blue": "Bughaw na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.brown": "Kayumangging Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.gray": "Abong Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.green": "Lungtiang Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Langit na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Pilak na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.lime": "Dayap na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.magenta": "Mahentang Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.orange": "Bulantubig na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.pink": "Kalimbahing Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.purple": "Habang Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.red": "Pulang Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.white": "Puting Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_left.yellow": "Dilaw na Putol na Baliktad",
  "block.minecraft.banner.diagonal_up_right.black": "Itim na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.blue": "Bughaw na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.brown": "Kayumangging Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.gray": "Abong Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.green": "Lungtiang Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Langit na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Pilak na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.lime": "Dayap na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.magenta": "Mahentang Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.orange": "Bulantubig na Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.pink": "Kalimbahing Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.purple": "Habang Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.red": "Pulang Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.white": "Puting Hiwa na Baliktad",
  "block.minecraft.banner.diagonal_up_right.yellow": "Dilaw na Hiwa na Baliktad",
  "block.minecraft.banner.flow.black": "Itim na Daloy",
  "block.minecraft.banner.flow.blue": "Bughaw na Daloy",
  "block.minecraft.banner.flow.brown": "Kayumangging Daloy",
  "block.minecraft.banner.flow.cyan": "Cyan na Daloy",
  "block.minecraft.banner.flow.gray": "Abong Daloy",
  "block.minecraft.banner.flow.green": "Lungtiang Daloy",
  "block.minecraft.banner.flow.light_blue": "Langit na Espiral",
  "block.minecraft.banner.flow.light_gray": "Pilak na Daloy",
  "block.minecraft.banner.flow.lime": "Dayap na Daloy",
  "block.minecraft.banner.flow.magenta": "Mahentang Daloy",
  "block.minecraft.banner.flow.orange": "Bulantubig na Daloy",
  "block.minecraft.banner.flow.pink": "Kalimbahing Espiral",
  "block.minecraft.banner.flow.purple": "Habang Daloy",
  "block.minecraft.banner.flow.red": "Pulang Espiral",
  "block.minecraft.banner.flow.white": "Puting Daloy",
  "block.minecraft.banner.flow.yellow": "Dilaw na Daloy",
  "block.minecraft.banner.flower.black": "Itim na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.blue": "Bughaw na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.brown": "Kayumangging Selyo ng Bulaklak",
  "block.minecraft.banner.flower.cyan": "Cyan na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.gray": "Abong Selyo ng Bulaklak",
  "block.minecraft.banner.flower.green": "Lungtiang Selyo ng Bulaklak",
  "block.minecraft.banner.flower.light_blue": "Langit na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.light_gray": "Pilak na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.lime": "Dayap na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.magenta": "Mahentang Selyo ng Bulaklak",
  "block.minecraft.banner.flower.orange": "Bulantubig na Selyo ng Bulaklak",
  "block.minecraft.banner.flower.pink": "Kalimbahing Selyo ng Bulaklak",
  "block.minecraft.banner.flower.purple": "Habang Tatak ng Bulaklak",
  "block.minecraft.banner.flower.red": "Pulang Selyo ng Bulaklak",
  "block.minecraft.banner.flower.white": "Puting Selyo ng Bulaklak",
  "block.minecraft.banner.flower.yellow": "Dilaw na Selyo ng Bulaklak",
  "block.minecraft.banner.globe.black": "Itim na Hilihid",
  "block.minecraft.banner.globe.blue": "Bughaw na Hilihid",
  "block.minecraft.banner.globe.brown": "Kayumangging Hilihid",
  "block.minecraft.banner.globe.cyan": "Cyan na Hilihid",
  "block.minecraft.banner.globe.gray": "Abong Hilihid",
  "block.minecraft.banner.globe.green": "Lungtiang Hilihid",
  "block.minecraft.banner.globe.light_blue": "Langit na Hilihid",
  "block.minecraft.banner.globe.light_gray": "Pilak na Hilihid",
  "block.minecraft.banner.globe.lime": "Dayap na Hilihid",
  "block.minecraft.banner.globe.magenta": "Mahentang Hilihid",
  "block.minecraft.banner.globe.orange": "Bulantubig na Hilihid",
  "block.minecraft.banner.globe.pink": "Kalimbahing Hilihid",
  "block.minecraft.banner.globe.purple": "Habang Hilihid",
  "block.minecraft.banner.globe.red": "Pulang Hilihid",
  "block.minecraft.banner.globe.white": "Puting Hilihid",
  "block.minecraft.banner.globe.yellow": "Dilaw na Hilihid",
  "block.minecraft.banner.gradient.black": "Itim na Silaw",
  "block.minecraft.banner.gradient.blue": "Bughaw na Silaw",
  "block.minecraft.banner.gradient.brown": "Kayumangging Silaw",
  "block.minecraft.banner.gradient.cyan": "Cyan na Silaw",
  "block.minecraft.banner.gradient.gray": "Abong Silaw",
  "block.minecraft.banner.gradient.green": "Lungtiang Silaw",
  "block.minecraft.banner.gradient.light_blue": "Langit na Silaw",
  "block.minecraft.banner.gradient.light_gray": "Pilak na Silaw",
  "block.minecraft.banner.gradient.lime": "Dayap na Silaw",
  "block.minecraft.banner.gradient.magenta": "Mahentang Silaw",
  "block.minecraft.banner.gradient.orange": "Bulantubig na Silaw",
  "block.minecraft.banner.gradient.pink": "Kalimbahing Silaw",
  "block.minecraft.banner.gradient.purple": "Habang Silaw",
  "block.minecraft.banner.gradient.red": "Pulang Silaw",
  "block.minecraft.banner.gradient.white": "Puting Silaw",
  "block.minecraft.banner.gradient.yellow": "Dilaw na Silaw",
  "block.minecraft.banner.gradient_up.black": "Itim na Lawag",
  "block.minecraft.banner.gradient_up.blue": "Bughaw na Lawag",
  "block.minecraft.banner.gradient_up.brown": "Kayumangging Lawag",
  "block.minecraft.banner.gradient_up.cyan": "Cyan na Lawag",
  "block.minecraft.banner.gradient_up.gray": "Abong Lawag",
  "block.minecraft.banner.gradient_up.green": "Lungtiang Lawag",
  "block.minecraft.banner.gradient_up.light_blue": "Langit na Lawag",
  "block.minecraft.banner.gradient_up.light_gray": "Pilak na Lawag",
  "block.minecraft.banner.gradient_up.lime": "Dayap na Lawag",
  "block.minecraft.banner.gradient_up.magenta": "Mahentang Lawag",
  "block.minecraft.banner.gradient_up.orange": "Bulantubig na Lawag",
  "block.minecraft.banner.gradient_up.pink": "Kalimbahing Lawag",
  "block.minecraft.banner.gradient_up.purple": "Habang Lawag",
  "block.minecraft.banner.gradient_up.red": "Pulang Lawag",
  "block.minecraft.banner.gradient_up.white": "Puting Lawag",
  "block.minecraft.banner.gradient_up.yellow": "Dilaw na Lawag",
  "block.minecraft.banner.guster.black": "Itim na Simoy",
  "block.minecraft.banner.guster.blue": "Bughaw na Simoy",
  "block.minecraft.banner.guster.brown": "Kayumangging Simoy",
  "block.minecraft.banner.guster.cyan": "Cyan na Simoy",
  "block.minecraft.banner.guster.gray": "Abong Simoy",
  "block.minecraft.banner.guster.green": "Lungtiang Simoy",
  "block.minecraft.banner.guster.light_blue": "Langit na Simoy",
  "block.minecraft.banner.guster.light_gray": "Pilak na Simoy",
  "block.minecraft.banner.guster.lime": "Dayap na Simoy",
  "block.minecraft.banner.guster.magenta": "Mahentang Simoy",
  "block.minecraft.banner.guster.orange": "Bulantubig na Simoy",
  "block.minecraft.banner.guster.pink": "Kalimbahing Simoy",
  "block.minecraft.banner.guster.purple": "Habang Simoy",
  "block.minecraft.banner.guster.red": "Pulang Simoy",
  "block.minecraft.banner.guster.white": "Puting Simoy",
  "block.minecraft.banner.guster.yellow": "Dilaw na Simoy",
  "block.minecraft.banner.half_horizontal.black": "Itim na Gupit",
  "block.minecraft.banner.half_horizontal.blue": "Bughaw na Gupit",
  "block.minecraft.banner.half_horizontal.brown": "Kayumangging Gupit",
  "block.minecraft.banner.half_horizontal.cyan": "Cyan na Gupit",
  "block.minecraft.banner.half_horizontal.gray": "Abong Gupit",
  "block.minecraft.banner.half_horizontal.green": "Lungtiang Gupit",
  "block.minecraft.banner.half_horizontal.light_blue": "Langit na Gupit",
  "block.minecraft.banner.half_horizontal.light_gray": "Pilak na Gupit",
  "block.minecraft.banner.half_horizontal.lime": "Dayap na Gupit",
  "block.minecraft.banner.half_horizontal.magenta": "Mahentang Gupit",
  "block.minecraft.banner.half_horizontal.orange": "Bulantubig na Gupit",
  "block.minecraft.banner.half_horizontal.pink": "Kalimbahing Gupit",
  "block.minecraft.banner.half_horizontal.purple": "Habang Itaas na Gupit",
  "block.minecraft.banner.half_horizontal.red": "Pulang Gupit",
  "block.minecraft.banner.half_horizontal.white": "Puting Gupit",
  "block.minecraft.banner.half_horizontal.yellow": "Dilaw na Gupit",
  "block.minecraft.banner.half_horizontal_bottom.black": "Itim na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Bughaw na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Kayumangging Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyan na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Abong Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.green": "Lungtiang Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Langit na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Pilak na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Dayap na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Mahentang Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Bulantubig na Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Kalimbahing Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Habang Ibabang Gupit",
  "block.minecraft.banner.half_horizontal_bottom.red": "Pulang Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.white": "Puting Gupit na Baliktad",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Dilaw na Gupit na Baliktad",
  "block.minecraft.banner.half_vertical.black": "Itim na Gilid",
  "block.minecraft.banner.half_vertical.blue": "Bughaw na Gilid",
  "block.minecraft.banner.half_vertical.brown": "Kayumangging Gilid",
  "block.minecraft.banner.half_vertical.cyan": "Cyan na Gilid",
  "block.minecraft.banner.half_vertical.gray": "Abong Gilid",
  "block.minecraft.banner.half_vertical.green": "Lungtiang Gilid",
  "block.minecraft.banner.half_vertical.light_blue": "Langit na Gilid",
  "block.minecraft.banner.half_vertical.light_gray": "Pilak na Gilid",
  "block.minecraft.banner.half_vertical.lime": "Dayap na Gilid",
  "block.minecraft.banner.half_vertical.magenta": "Mahentang Gilid",
  "block.minecraft.banner.half_vertical.orange": "Bulantubig na Gilid",
  "block.minecraft.banner.half_vertical.pink": "Kalimbahing Gilid",
  "block.minecraft.banner.half_vertical.purple": "Habang Kaliwang Panig",
  "block.minecraft.banner.half_vertical.red": "Pulang Gilid",
  "block.minecraft.banner.half_vertical.white": "Puting Gilid",
  "block.minecraft.banner.half_vertical.yellow": "Dilaw na Gilid",
  "block.minecraft.banner.half_vertical_right.black": "Itim na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.blue": "Bughaw na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.brown": "Kayumangging Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyan na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.gray": "Abong Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.green": "Lungtiang Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.light_blue": "Langit na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.light_gray": "Pilak na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.lime": "Dayap na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.magenta": "Mahentang Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.orange": "Bulantubig na Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.pink": "Kalimbahing Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.purple": "Habang Kanang Panig",
  "block.minecraft.banner.half_vertical_right.red": "Pulang Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.white": "Puting Gilid na Baliktad",
  "block.minecraft.banner.half_vertical_right.yellow": "Dilaw na Gilid na Baliktad",
  "block.minecraft.banner.mojang.black": "Itim na Kuwan",
  "block.minecraft.banner.mojang.blue": "Bughaw na Kuwan",
  "block.minecraft.banner.mojang.brown": "Kayumangging Kuwan",
  "block.minecraft.banner.mojang.cyan": "Cyan na Kuwan",
  "block.minecraft.banner.mojang.gray": "Abong Kuwan",
  "block.minecraft.banner.mojang.green": "Lungtiang Kuwan",
  "block.minecraft.banner.mojang.light_blue": "Langit na Kuwan",
  "block.minecraft.banner.mojang.light_gray": "Pilak na Kuwan",
  "block.minecraft.banner.mojang.lime": "Dayap na Kuwan",
  "block.minecraft.banner.mojang.magenta": "Mahentang Kuwan",
  "block.minecraft.banner.mojang.orange": "Bulantubig na Kuwan",
  "block.minecraft.banner.mojang.pink": "Kalimbahing Kuwan",
  "block.minecraft.banner.mojang.purple": "Habang Kuwan",
  "block.minecraft.banner.mojang.red": "Pulang Kuwan",
  "block.minecraft.banner.mojang.white": "Puting Kuwan",
  "block.minecraft.banner.mojang.yellow": "Dilaw na Kuwan",
  "block.minecraft.banner.piglin.black": "Itim na Nguso",
  "block.minecraft.banner.piglin.blue": "Bughaw na Nguso",
  "block.minecraft.banner.piglin.brown": "Kayumangging Nguso",
  "block.minecraft.banner.piglin.cyan": "Cyan na Nguso",
  "block.minecraft.banner.piglin.gray": "Abong Nguso",
  "block.minecraft.banner.piglin.green": "Lungtiang Nguso",
  "block.minecraft.banner.piglin.light_blue": "Langit na Nguso",
  "block.minecraft.banner.piglin.light_gray": "Pilak na Nguso",
  "block.minecraft.banner.piglin.lime": "Dayap na Nguso",
  "block.minecraft.banner.piglin.magenta": "Mahentang Nguso",
  "block.minecraft.banner.piglin.orange": "Bulantubig na Nguso",
  "block.minecraft.banner.piglin.pink": "Kalimbahing Nguso",
  "block.minecraft.banner.piglin.purple": "Habang Nguso",
  "block.minecraft.banner.piglin.red": "Pulang Nguso",
  "block.minecraft.banner.piglin.white": "Puting Nguso",
  "block.minecraft.banner.piglin.yellow": "Dilaw na Nguso",
  "block.minecraft.banner.rhombus.black": "Itim na Losanggo",
  "block.minecraft.banner.rhombus.blue": "Bughaw na Losanggo",
  "block.minecraft.banner.rhombus.brown": "Kayumangging Losanggo",
  "block.minecraft.banner.rhombus.cyan": "Cyan na Losanggo",
  "block.minecraft.banner.rhombus.gray": "Abong Losanggo",
  "block.minecraft.banner.rhombus.green": "Lungtiang Losanggo",
  "block.minecraft.banner.rhombus.light_blue": "Langit na Losanggo",
  "block.minecraft.banner.rhombus.light_gray": "Pilak na Losanggo",
  "block.minecraft.banner.rhombus.lime": "Dayap na Losanggo",
  "block.minecraft.banner.rhombus.magenta": "Mahentang Losanggo",
  "block.minecraft.banner.rhombus.orange": "Bulantubig na Losanggo",
  "block.minecraft.banner.rhombus.pink": "Kalimbahing Losanggo",
  "block.minecraft.banner.rhombus.purple": "Habang Tagisukat",
  "block.minecraft.banner.rhombus.red": "Pulang Losanggo",
  "block.minecraft.banner.rhombus.white": "Puting Losanggo",
  "block.minecraft.banner.rhombus.yellow": "Dilaw na Losanggo",
  "block.minecraft.banner.skull.black": "Itim na Selyo ng Bungo",
  "block.minecraft.banner.skull.blue": "Bughaw na Selyo ng Bungo",
  "block.minecraft.banner.skull.brown": "Kayumangging Selyo ng Bungo",
  "block.minecraft.banner.skull.cyan": "Cyan na Selyo ng Bungo",
  "block.minecraft.banner.skull.gray": "Abong Selyo ng Bungo",
  "block.minecraft.banner.skull.green": "Lungtiang Selyo ng Bungo",
  "block.minecraft.banner.skull.light_blue": "Langit na Selyo ng Bungo",
  "block.minecraft.banner.skull.light_gray": "Pilak na Selyo ng Bungo",
  "block.minecraft.banner.skull.lime": "Dayap na Selyo ng Bungo",
  "block.minecraft.banner.skull.magenta": "Mahentang Selyo ng Bungo",
  "block.minecraft.banner.skull.orange": "Bulantubig na Selyo ng Bungo",
  "block.minecraft.banner.skull.pink": "Kalimbahing Selyo ng Bungo",
  "block.minecraft.banner.skull.purple": "Habang Tatak ng Bungo",
  "block.minecraft.banner.skull.red": "Pulang Selyo ng Bungo",
  "block.minecraft.banner.skull.white": "Puting Selyo ng Bungo",
  "block.minecraft.banner.skull.yellow": "Dilaw na Selyo ng Bungo",
  "block.minecraft.banner.small_stripes.black": "Itim na Sinag",
  "block.minecraft.banner.small_stripes.blue": "Bughaw na Sinag",
  "block.minecraft.banner.small_stripes.brown": "Kayumangging Sinag",
  "block.minecraft.banner.small_stripes.cyan": "Cyan na Sinag",
  "block.minecraft.banner.small_stripes.gray": "Abong Sinag",
  "block.minecraft.banner.small_stripes.green": "Lungtiang Sinag",
  "block.minecraft.banner.small_stripes.light_blue": "Langit na Sinag",
  "block.minecraft.banner.small_stripes.light_gray": "Pilak na Sinag",
  "block.minecraft.banner.small_stripes.lime": "Dayap na Sinag",
  "block.minecraft.banner.small_stripes.magenta": "Mahentang Sinag",
  "block.minecraft.banner.small_stripes.orange": "Bulantubig na Sinag",
  "block.minecraft.banner.small_stripes.pink": "Kalimbahing Sinag",
  "block.minecraft.banner.small_stripes.purple": "Habang Sinag",
  "block.minecraft.banner.small_stripes.red": "Pulang Sinag",
  "block.minecraft.banner.small_stripes.white": "Puting Sinag",
  "block.minecraft.banner.small_stripes.yellow": "Dilaw na Sinag",
  "block.minecraft.banner.square_bottom_left.black": "Itim na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.blue": "Bughaw na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.brown": "Kayumangging Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.cyan": "Cyan na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.gray": "Abong Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.green": "Lungtiang Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.light_blue": "Langit na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.light_gray": "Pilak na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.lime": "Dayap na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.magenta": "Mahentang Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.orange": "Bulantubig na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.pink": "Kalimbahing Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.purple": "Habang Kaliwang Ibabang Sulok",
  "block.minecraft.banner.square_bottom_left.red": "Pulang Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.white": "Puting Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_left.yellow": "Dilaw na Kantong Kaliwang Ibaba",
  "block.minecraft.banner.square_bottom_right.black": "Itim na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.blue": "Bughaw na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.brown": "Kayumangging Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyan na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.gray": "Abong Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.green": "Lungtiang Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.light_blue": "Langit na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.light_gray": "Pilak na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.lime": "Dayap na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.magenta": "Mahentang Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.orange": "Bulantubig na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.pink": "Kalimbahing Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.purple": "Habang Kanang Ibabang Sulok",
  "block.minecraft.banner.square_bottom_right.red": "Pulang Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.white": "Puting Kantong Kanang Ibaba",
  "block.minecraft.banner.square_bottom_right.yellow": "Dilaw na Kantong Kanang Ibaba",
  "block.minecraft.banner.square_top_left.black": "Itim na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.blue": "Bughaw na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.brown": "Kayumangging Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.cyan": "Cyan na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.gray": "Abong Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.green": "Lungtiang Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.light_blue": "Langit na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.light_gray": "Pilak na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.lime": "Dayap na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.magenta": "Mahentang Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.orange": "Bulantubig na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.pink": "Kalimbahing Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.purple": "Habang Kaliwang Itaas na Sulok",
  "block.minecraft.banner.square_top_left.red": "Pulang Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.white": "Puting Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_left.yellow": "Dilaw na Kantong Kaliwang Hepe",
  "block.minecraft.banner.square_top_right.black": "Itim na Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.blue": "Bughaw na Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.brown": "Kayumangging Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.cyan": "Cyan na Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.gray": "Abong Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.green": "Lungtiang Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.light_blue": "Langit na Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.light_gray": "Pilak na Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.lime": "Lungtiang Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.magenta": "Mahentang Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.orange": "Bulantubig na Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.pink": "Kalimbahing Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.purple": "Habang Kanang Itaas na Sulok",
  "block.minecraft.banner.square_top_right.red": "Pulang Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.white": "Puting Kantong Kanang Hepe",
  "block.minecraft.banner.square_top_right.yellow": "Dilaw na Kantong Kanang Hepe",
  "block.minecraft.banner.straight_cross.black": "Itim na Dipa",
  "block.minecraft.banner.straight_cross.blue": "Bughaw na Dipa",
  "block.minecraft.banner.straight_cross.brown": "Kayumangging Dipa",
  "block.minecraft.banner.straight_cross.cyan": "Cyan na Dipa",
  "block.minecraft.banner.straight_cross.gray": "Abong Dipa",
  "block.minecraft.banner.straight_cross.green": "Lungtiang Dipa",
  "block.minecraft.banner.straight_cross.light_blue": "Langit na Dipa",
  "block.minecraft.banner.straight_cross.light_gray": "Pilak na Dipa",
  "block.minecraft.banner.straight_cross.lime": "Dayap na Dipa",
  "block.minecraft.banner.straight_cross.magenta": "Mahentang Dipa",
  "block.minecraft.banner.straight_cross.orange": "Bulantubig na Dipa",
  "block.minecraft.banner.straight_cross.pink": "Kalimbahing Dipa",
  "block.minecraft.banner.straight_cross.purple": "Habang Dipa",
  "block.minecraft.banner.straight_cross.red": "Pulang Dipa",
  "block.minecraft.banner.straight_cross.white": "Puting Dipa",
  "block.minecraft.banner.straight_cross.yellow": "Dilaw na Dipa",
  "block.minecraft.banner.stripe_bottom.black": "Itim na Ibaba",
  "block.minecraft.banner.stripe_bottom.blue": "Bughaw na Ibaba",
  "block.minecraft.banner.stripe_bottom.brown": "Kayumangging Ibaba",
  "block.minecraft.banner.stripe_bottom.cyan": "Cyan na Ibaba",
  "block.minecraft.banner.stripe_bottom.gray": "Abong Ibaba",
  "block.minecraft.banner.stripe_bottom.green": "Lungtiang Ibaba",
  "block.minecraft.banner.stripe_bottom.light_blue": "Langit na Ibaba",
  "block.minecraft.banner.stripe_bottom.light_gray": "Pilak na Ibaba",
  "block.minecraft.banner.stripe_bottom.lime": "Dayap na Ibaba",
  "block.minecraft.banner.stripe_bottom.magenta": "Mahentang Ibaba",
  "block.minecraft.banner.stripe_bottom.orange": "Bulantubig na Ibaba",
  "block.minecraft.banner.stripe_bottom.pink": "Kalimbahing Ibaba",
  "block.minecraft.banner.stripe_bottom.purple": "Habang Ibaba",
  "block.minecraft.banner.stripe_bottom.red": "Pulang Ibaba",
  "block.minecraft.banner.stripe_bottom.white": "Puting Ibaba",
  "block.minecraft.banner.stripe_bottom.yellow": "Dilaw na Ibaba",
  "block.minecraft.banner.stripe_center.black": "Itim na Gitna",
  "block.minecraft.banner.stripe_center.blue": "Bughaw na Gitna",
  "block.minecraft.banner.stripe_center.brown": "Kayumangging Gitna",
  "block.minecraft.banner.stripe_center.cyan": "Cyan na Gitna",
  "block.minecraft.banner.stripe_center.gray": "Abong Gitna",
  "block.minecraft.banner.stripe_center.green": "Lungtiang Gitna",
  "block.minecraft.banner.stripe_center.light_blue": "Langit na Gitna",
  "block.minecraft.banner.stripe_center.light_gray": "Pilak na Gitna",
  "block.minecraft.banner.stripe_center.lime": "Dayap na Gitna",
  "block.minecraft.banner.stripe_center.magenta": "Mahentang Gitna",
  "block.minecraft.banner.stripe_center.orange": "Bulantubig na Gitna",
  "block.minecraft.banner.stripe_center.pink": "Kalimbahing Gitna",
  "block.minecraft.banner.stripe_center.purple": "Habang Gitna",
  "block.minecraft.banner.stripe_center.red": "Pulang Gitna",
  "block.minecraft.banner.stripe_center.white": "Puting Gitna",
  "block.minecraft.banner.stripe_center.yellow": "Dilaw na Gitna",
  "block.minecraft.banner.stripe_downleft.black": "Itim na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.blue": "Bughaw na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.brown": "Kayumangging Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyan na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.gray": "Abong Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.green": "Lungtiang Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.light_blue": "Langit na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.light_gray": "Pilak na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.lime": "Dayap na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.magenta": "Mahentang Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.orange": "Bulantubig na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.pink": "Kalimbahing Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.purple": "Habang Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.red": "Pulang Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.white": "Puting Pababang Kaliwa",
  "block.minecraft.banner.stripe_downleft.yellow": "Dilaw na Pababang Kaliwa",
  "block.minecraft.banner.stripe_downright.black": "Itim na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.blue": "Bughaw na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.brown": "Kayumangging Pababang Kanan",
  "block.minecraft.banner.stripe_downright.cyan": "Cyan na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.gray": "Abong Pababang Kanan",
  "block.minecraft.banner.stripe_downright.green": "Lungtiang Pababang Kanan",
  "block.minecraft.banner.stripe_downright.light_blue": "Langit na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.light_gray": "Pilak na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.lime": "Dayap na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.magenta": "Mahentang Pababang Kanan",
  "block.minecraft.banner.stripe_downright.orange": "Bulantubig na Pababang Kanan",
  "block.minecraft.banner.stripe_downright.pink": "Kalimbahing Pababang Kanan",
  "block.minecraft.banner.stripe_downright.purple": "Habang Pababang Kanan",
  "block.minecraft.banner.stripe_downright.red": "Pulang Pababang Kanan",
  "block.minecraft.banner.stripe_downright.white": "Puting Pababang Kanan",
  "block.minecraft.banner.stripe_downright.yellow": "Dilaw na Pababang Kanan",
  "block.minecraft.banner.stripe_left.black": "Itim na Kaliwa",
  "block.minecraft.banner.stripe_left.blue": "Bughaw na Kaliwa",
  "block.minecraft.banner.stripe_left.brown": "Kayumangging Kaliwa",
  "block.minecraft.banner.stripe_left.cyan": "Cyan na Kaliwa",
  "block.minecraft.banner.stripe_left.gray": "Abong Kaliwa",
  "block.minecraft.banner.stripe_left.green": "Lungtiang Kaliwa",
  "block.minecraft.banner.stripe_left.light_blue": "Langit na Kaliwa",
  "block.minecraft.banner.stripe_left.light_gray": "Pilak na Kaliwa",
  "block.minecraft.banner.stripe_left.lime": "Dayap na Kaliwa",
  "block.minecraft.banner.stripe_left.magenta": "Mahentang Kaliwa",
  "block.minecraft.banner.stripe_left.orange": "Bulantubig na Kaliwa",
  "block.minecraft.banner.stripe_left.pink": "Kalimbahing Kaliwa",
  "block.minecraft.banner.stripe_left.purple": "Habang Kaliwa",
  "block.minecraft.banner.stripe_left.red": "Pulang Kaliwa",
  "block.minecraft.banner.stripe_left.white": "Puting Kaliwa",
  "block.minecraft.banner.stripe_left.yellow": "Dilaw na Kaliwa",
  "block.minecraft.banner.stripe_middle.black": "Itim na Palawit",
  "block.minecraft.banner.stripe_middle.blue": "Bughaw na Palawit",
  "block.minecraft.banner.stripe_middle.brown": "Kayumangging Palawit",
  "block.minecraft.banner.stripe_middle.cyan": "Cyan na Palawit",
  "block.minecraft.banner.stripe_middle.gray": "Abong Palawit",
  "block.minecraft.banner.stripe_middle.green": "Lungtiang Palawit",
  "block.minecraft.banner.stripe_middle.light_blue": "Langit na Palawit",
  "block.minecraft.banner.stripe_middle.light_gray": "Pilak na Palawit",
  "block.minecraft.banner.stripe_middle.lime": "Dayap na Palawit",
  "block.minecraft.banner.stripe_middle.magenta": "Mahentang Palawit",
  "block.minecraft.banner.stripe_middle.orange": "Bulantubig na Palawit",
  "block.minecraft.banner.stripe_middle.pink": "Kalimbahing Palawit",
  "block.minecraft.banner.stripe_middle.purple": "Habang Palawit",
  "block.minecraft.banner.stripe_middle.red": "Pulang Palawit",
  "block.minecraft.banner.stripe_middle.white": "Puting Palawit",
  "block.minecraft.banner.stripe_middle.yellow": "Dilaw na Palawit",
  "block.minecraft.banner.stripe_right.black": "Itim na Kanan",
  "block.minecraft.banner.stripe_right.blue": "Bughaw na Kanan",
  "block.minecraft.banner.stripe_right.brown": "Kayumangging Kanan",
  "block.minecraft.banner.stripe_right.cyan": "Cyan na Kanan",
  "block.minecraft.banner.stripe_right.gray": "Abong Kanan",
  "block.minecraft.banner.stripe_right.green": "Lungtiang Kanan",
  "block.minecraft.banner.stripe_right.light_blue": "Langit na Kanan",
  "block.minecraft.banner.stripe_right.light_gray": "Pilak na Kanan",
  "block.minecraft.banner.stripe_right.lime": "Dayap na Kanan",
  "block.minecraft.banner.stripe_right.magenta": "Mahentang Kanan",
  "block.minecraft.banner.stripe_right.orange": "Bulantubig na Kanan",
  "block.minecraft.banner.stripe_right.pink": "Kalimbahing Kanan",
  "block.minecraft.banner.stripe_right.purple": "Habang Kanan",
  "block.minecraft.banner.stripe_right.red": "Pulang Kanan",
  "block.minecraft.banner.stripe_right.white": "Puting Kanan",
  "block.minecraft.banner.stripe_right.yellow": "Dilaw na Kanan",
  "block.minecraft.banner.stripe_top.black": "Itim na Itaas",
  "block.minecraft.banner.stripe_top.blue": "Bughaw na Itaas",
  "block.minecraft.banner.stripe_top.brown": "Kayumangging Itaas",
  "block.minecraft.banner.stripe_top.cyan": "Cyan na Itaas",
  "block.minecraft.banner.stripe_top.gray": "Abong Itaas",
  "block.minecraft.banner.stripe_top.green": "Lungtiang Itaas",
  "block.minecraft.banner.stripe_top.light_blue": "Langit na Itaas",
  "block.minecraft.banner.stripe_top.light_gray": "Pilak na Itaas",
  "block.minecraft.banner.stripe_top.lime": "Dayap na Itaas",
  "block.minecraft.banner.stripe_top.magenta": "Mahentang Itaas",
  "block.minecraft.banner.stripe_top.orange": "Bulantubig na Itaas",
  "block.minecraft.banner.stripe_top.pink": "Kalimbahing Itaas",
  "block.minecraft.banner.stripe_top.purple": "Habang Itaas",
  "block.minecraft.banner.stripe_top.red": "Pulang Itaas",
  "block.minecraft.banner.stripe_top.white": "Puting Itaas",
  "block.minecraft.banner.stripe_top.yellow": "Dilaw na Itaas",
  "block.minecraft.banner.triangle_bottom.black": "Itim na Tsebron",
  "block.minecraft.banner.triangle_bottom.blue": "Bughaw na Tsebron",
  "block.minecraft.banner.triangle_bottom.brown": "Kayumangging Tsebron",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyan na Tsebron",
  "block.minecraft.banner.triangle_bottom.gray": "Abong Tsebron",
  "block.minecraft.banner.triangle_bottom.green": "Lungtiang Tsebron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Langit na Tsebron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Pilak na Tsebron",
  "block.minecraft.banner.triangle_bottom.lime": "Dayap na Tsebron",
  "block.minecraft.banner.triangle_bottom.magenta": "Mahentang Tsebron",
  "block.minecraft.banner.triangle_bottom.orange": "Bulantubig na Tsebron",
  "block.minecraft.banner.triangle_bottom.pink": "Kalimbahing Tsebron",
  "block.minecraft.banner.triangle_bottom.purple": "Habang Bubong",
  "block.minecraft.banner.triangle_bottom.red": "Pulang Tsebron",
  "block.minecraft.banner.triangle_bottom.white": "Puting Tsebron",
  "block.minecraft.banner.triangle_bottom.yellow": "Dilaw na Tsebron",
  "block.minecraft.banner.triangle_top.black": "Itim na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.blue": "Bughaw na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.brown": "Kayumangging Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.cyan": "Cyan na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.gray": "Abong Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.green": "Lungtiang Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.light_blue": "Langit na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.light_gray": "Pilak na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.lime": "Dayap na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.magenta": "Mahentang Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.orange": "Bulantubig na Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.pink": "Kalimbahing Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.purple": "Habang Bubong na Nilipad",
  "block.minecraft.banner.triangle_top.red": "Pulang Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.white": "Puting Tsebrong Baliktad",
  "block.minecraft.banner.triangle_top.yellow": "Dilaw na Tsebrong Baliktad",
  "block.minecraft.banner.triangles_bottom.black": "Itim na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.blue": "Bughaw na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.brown": "Kayumangging Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyan na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.gray": "Abong Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.green": "Lungtiang Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.light_blue": "Langit na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.light_gray": "Pilak na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.lime": "Dayap na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.magenta": "Mahentang Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.orange": "Bulantubig na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.pink": "Kalimbahing Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.purple": "Habang Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.red": "Pulang Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.white": "Puting Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_bottom.yellow": "Dilaw na Ibabang Yupi-yupi",
  "block.minecraft.banner.triangles_top.black": "Itim na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.blue": "Bughaw na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.brown": "Kayumangging Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.cyan": "Cyan na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.gray": "Abong Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.green": "Lungtiang Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.light_blue": "Langit na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.light_gray": "Pilak na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.lime": "Dayap na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.magenta": "Mahentang Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.orange": "Bulantubig na Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.pink": "Kalimbahing Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.purple": "Habang Itaas na Yupi-yupi",
  "block.minecraft.banner.triangles_top.red": "Pulang Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.white": "Puting Hepeng Yupi-yupi",
  "block.minecraft.banner.triangles_top.yellow": "Dilaw na Hepeng Yupi-yupi",
  "block.minecraft.barrel": "Bariles",
  "block.minecraft.barrier": "Harang",
  "block.minecraft.basalt": "Batumbakal",
  "block.minecraft.beacon": "Tanglaw",
  "block.minecraft.beacon.primary": "Pangunahing Lakas",
  "block.minecraft.beacon.secondary": "Pangalawang Lakas",
  "block.minecraft.bed.no_sleep": "Makatutulog ka lamang sa gabi o tuwing bumabagyo",
  "block.minecraft.bed.not_safe": "Bawal munang magpahinga; malapit ang mga halimaw",
  "block.minecraft.bed.obstructed": "May nakaharang sa higaang ito",
  "block.minecraft.bed.occupied": "May natutulog sa higaang ito",
  "block.minecraft.bed.too_far_away": "Hindi ka makatutulog ngayon; lubhang malayo ang higaan",
  "block.minecraft.bedrock": "Batunlunas",
  "block.minecraft.bee_nest": "Pugad ng Bubuyog",
  "block.minecraft.beehive": "Bahay-pukyutan",
  "block.minecraft.beetroots": "Remolatsa",
  "block.minecraft.bell": "Batingaw",
  "block.minecraft.big_dripleaf": "Malaking Tulundahon",
  "block.minecraft.big_dripleaf_stem": "Malaking Tulundahong Tangkay",
  "block.minecraft.birch_button": "Abedul na Pindutan",
  "block.minecraft.birch_door": "Abedul na Pinto",
  "block.minecraft.birch_fence": "Abedul na Bakod",
  "block.minecraft.birch_fence_gate": "Abedul na Tarangkahan",
  "block.minecraft.birch_hanging_sign": "Abedul na Karatulang Nakasabit",
  "block.minecraft.birch_leaves": "Dahon ng Abedul",
  "block.minecraft.birch_log": "Abedul na Troso",
  "block.minecraft.birch_planks": "Abedul na Tabla",
  "block.minecraft.birch_pressure_plate": "Abedul na Apakan",
  "block.minecraft.birch_sapling": "Punla ng Abedul",
  "block.minecraft.birch_shelf": "Abedul na Salansanan",
  "block.minecraft.birch_sign": "Abedul na Karatula",
  "block.minecraft.birch_slab": "Abedul na Dalig",
  "block.minecraft.birch_stairs": "Abedul na Hagdanan",
  "block.minecraft.birch_trapdoor": "Abedul na Bukasan",
  "block.minecraft.birch_wall_hanging_sign": "Abedul na Karatulang Nakasabit sa Pader",
  "block.minecraft.birch_wall_sign": "Abedul na Karatula sa Pader",
  "block.minecraft.birch_wood": "Abedul na Kahoy",
  "block.minecraft.black_banner": "Itim na Watawat",
  "block.minecraft.black_bed": "Itim na Higaan",
  "block.minecraft.black_candle": "Itim na Sasang",
  "block.minecraft.black_candle_cake": "Keyk na may Itim na Sasang",
  "block.minecraft.black_carpet": "Itim na Banig",
  "block.minecraft.black_concrete": "Itim na Gawambato",
  "block.minecraft.black_concrete_powder": "Itim na Gawambatong Buhangin",
  "block.minecraft.black_glazed_terracotta": "Itim na Sinalaminang Lutunlupa",
  "block.minecraft.black_shulker_box": "Itim na Kahon ng Shulker",
  "block.minecraft.black_stained_glass": "Itim na Salamin",
  "block.minecraft.black_stained_glass_pane": "Itim na Durungawan",
  "block.minecraft.black_terracotta": "Itim na Lutunlupa",
  "block.minecraft.black_wool": "Itim na Lana",
  "block.minecraft.blackstone": "Batungitim",
  "block.minecraft.blackstone_slab": "Batungitim na Dalig",
  "block.minecraft.blackstone_stairs": "Batungitim na Hagdanan",
  "block.minecraft.blackstone_wall": "Batungitim na Pader",
  "block.minecraft.blast_furnace": "Dagisdising Dapugan",
  "block.minecraft.blue_banner": "Bughaw na Watawat",
  "block.minecraft.blue_bed": "Bughaw na Higaan",
  "block.minecraft.blue_candle": "Bughaw na Sasang",
  "block.minecraft.blue_candle_cake": "Keyk na may Bughaw na Sasang",
  "block.minecraft.blue_carpet": "Bughaw na Banig",
  "block.minecraft.blue_concrete": "Bughaw na Gawambato",
  "block.minecraft.blue_concrete_powder": "Bughaw na Gawambatong Buhangin",
  "block.minecraft.blue_glazed_terracotta": "Bughaw na Sinalaminang Lutunlupa",
  "block.minecraft.blue_ice": "Bughaw na Yelo",
  "block.minecraft.blue_orchid": "Bughaw na Orkidia",
  "block.minecraft.blue_shulker_box": "Bughaw na Kahon ng Shulker",
  "block.minecraft.blue_stained_glass": "Bughaw na Salamin",
  "block.minecraft.blue_stained_glass_pane": "Bughaw na Durungawan",
  "block.minecraft.blue_terracotta": "Bughaw na Lutunlupa",
  "block.minecraft.blue_wool": "Bughaw na Lana",
  "block.minecraft.bone_block": "Bloke ng Buto",
  "block.minecraft.bookshelf": "Aklatang Salansanan",
  "block.minecraft.brain_coral": "Lamang-sagay",
  "block.minecraft.brain_coral_block": "Bloke ng Lamang-sagay",
  "block.minecraft.brain_coral_fan": "Lamang-paypaysagay",
  "block.minecraft.brain_coral_wall_fan": "Lamang-paypaysagay sa Pader",
  "block.minecraft.brewing_stand": "Alambike",
  "block.minecraft.brick_slab": "Laryong Dalig",
  "block.minecraft.brick_stairs": "Laryong Hagdanan",
  "block.minecraft.brick_wall": "Laryong Pader",
  "block.minecraft.bricks": "Laryo",
  "block.minecraft.brown_banner": "Kayumangging Watawat",
  "block.minecraft.brown_bed": "Kayumangging Higaan",
  "block.minecraft.brown_candle": "Kayumangging Sasang",
  "block.minecraft.brown_candle_cake": "Keyk na may Kayumangging Sasang",
  "block.minecraft.brown_carpet": "Kayumangging Banig",
  "block.minecraft.brown_concrete": "Kayumangging Gawambatong Buhangin",
  "block.minecraft.brown_concrete_powder": "Kayumangging Gawambatong Buhangin",
  "block.minecraft.brown_glazed_terracotta": "Kayumangging Sinalaminang Lutunlupa",
  "block.minecraft.brown_mushroom": "Kayumangging Kabute",
  "block.minecraft.brown_mushroom_block": "Bloke ng Kayumangging Kabute",
  "block.minecraft.brown_shulker_box": "Kayumangging Kahon ng Shulker",
  "block.minecraft.brown_stained_glass": "Kayumangging Salamin",
  "block.minecraft.brown_stained_glass_pane": "Kayumangging Durungawan",
  "block.minecraft.brown_terracotta": "Kayumangging Lutunlupa",
  "block.minecraft.brown_wool": "Kayumangging Lana",
  "block.minecraft.bubble_column": "Bloke ng Bula",
  "block.minecraft.bubble_coral": "Bulabulang-sagay",
  "block.minecraft.bubble_coral_block": "Bloke ng Bulabulang-sagay",
  "block.minecraft.bubble_coral_fan": "Bulabulang-paypaysagay",
  "block.minecraft.bubble_coral_wall_fan": "Bulabulang-paypaysagay sa Pader",
  "block.minecraft.budding_amethyst": "Umuusbong na Amatista",
  "block.minecraft.bush": "Palumpong",
  "block.minecraft.cactus": "Kakto",
  "block.minecraft.cactus_flower": "Bulaklak ng Kakto",
  "block.minecraft.cake": "Keyk",
  "block.minecraft.calcite": "Kalsita",
  "block.minecraft.calibrated_sculk_sensor": "Mapiling Pangganapbilusang Sculk",
  "block.minecraft.campfire": "Siga",
  "block.minecraft.candle": "Sasang",
  "block.minecraft.candle_cake": "Keyk na may Sasang",
  "block.minecraft.carrots": "Asanoryas",
  "block.minecraft.cartography_table": "Hapag-mapahan",
  "block.minecraft.carved_pumpkin": "Inukit na Kandos",
  "block.minecraft.cauldron": "Kaldero",
  "block.minecraft.cave_air": "Hangin ng Yungib",
  "block.minecraft.cave_vines": "Baging-yungib",
  "block.minecraft.cave_vines_plant": "Halamang Baging-yungib",
  "block.minecraft.chain": "Tanikala",
  "block.minecraft.chain_command_block": "Pakawing na Bloke ng Utos",
  "block.minecraft.cherry_button": "Sakurang Pindutan",
  "block.minecraft.cherry_door": "Sakurang Pinto",
  "block.minecraft.cherry_fence": "Sakurang Bakod",
  "block.minecraft.cherry_fence_gate": "Sakurang Tarangkahan",
  "block.minecraft.cherry_hanging_sign": "Sakurang Karatulang Nakasabit",
  "block.minecraft.cherry_leaves": "Dahon ng Sakura",
  "block.minecraft.cherry_log": "Sakurang Troso",
  "block.minecraft.cherry_planks": "Sakurang Tabla",
  "block.minecraft.cherry_pressure_plate": "Sakurang Apakan",
  "block.minecraft.cherry_sapling": "Punla ng Sakura",
  "block.minecraft.cherry_shelf": "Sakurang Salansanan",
  "block.minecraft.cherry_sign": "Sakurang Karatula",
  "block.minecraft.cherry_slab": "Sakurang Dalig",
  "block.minecraft.cherry_stairs": "Sakurang Hagdanan",
  "block.minecraft.cherry_trapdoor": "Sakurang Bukasan",
  "block.minecraft.cherry_wall_hanging_sign": "Sakurang Karatulang Nakasabit sa Pader",
  "block.minecraft.cherry_wall_sign": "Sakurang Karatula sa Pader",
  "block.minecraft.cherry_wood": "Sakurang Kahoy",
  "block.minecraft.chest": "Kaban",
  "block.minecraft.chipped_anvil": "Basag na Palihan",
  "block.minecraft.chiseled_bookshelf": "Pinaitang Aklatang Salansanan",
  "block.minecraft.chiseled_copper": "Pinaitang Tanso",
  "block.minecraft.chiseled_deepslate": "Pinaitang Pisaranlalim",
  "block.minecraft.chiseled_nether_bricks": "Pinaitang Laryong Nether",
  "block.minecraft.chiseled_polished_blackstone": "Pinaitang Binulihang Batungitim",
  "block.minecraft.chiseled_quartz_block": "Bloke ng Pinaitang Kinyang",
  "block.minecraft.chiseled_red_sandstone": "Pinaitang Pulang Batumbuhangin",
  "block.minecraft.chiseled_resin_bricks": "Pinaitang Laryong Dagta",
  "block.minecraft.chiseled_sandstone": "Pinaitang Batumbuhangin",
  "block.minecraft.chiseled_stone_bricks": "Pinaitang Laryong Bato",
  "block.minecraft.chiseled_tuff": "Pinaitang Tupo",
  "block.minecraft.chiseled_tuff_bricks": "Pinaitang Laryong Tupo",
  "block.minecraft.chorus_flower": "Korumbulak",
  "block.minecraft.chorus_plant": "Halamang-koro",
  "block.minecraft.clay": "Luwad",
  "block.minecraft.closed_eyeblossom": "Pikit na Matambulak",
  "block.minecraft.coal_block": "Bloke ng Batong-uling",
  "block.minecraft.coal_ore": "Dukaling Uling",
  "block.minecraft.coarse_dirt": "Lupang Magaspang",
  "block.minecraft.cobbled_deepslate": "Batubatong Pisaranlalim",
  "block.minecraft.cobbled_deepslate_slab": "Batubatong Pisaranlalim na Dalig",
  "block.minecraft.cobbled_deepslate_stairs": "Batubatong Pisaranlalim na Hagdanan",
  "block.minecraft.cobbled_deepslate_wall": "Batubatong Pisaranlalim na Pader",
  "block.minecraft.cobblestone": "Batubato",
  "block.minecraft.cobblestone_slab": "Batubatong Dalig",
  "block.minecraft.cobblestone_stairs": "Batubatong Hagdanan",
  "block.minecraft.cobblestone_wall": "Batubatong Pader",
  "block.minecraft.cobweb": "Sapot",
  "block.minecraft.cocoa": "Kakaw",
  "block.minecraft.command_block": "Bloke ng Utos",
  "block.minecraft.comparator": "Redstone Panghambing",
  "block.minecraft.composter": "Tagaabono",
  "block.minecraft.conduit": "Daluyan",
  "block.minecraft.copper_bars": "Tansong Rehas",
  "block.minecraft.copper_block": "Bloke ng Tanso",
  "block.minecraft.copper_bulb": "Bombilyang Tanso",
  "block.minecraft.copper_chain": "Tansong Tanikala",
  "block.minecraft.copper_chest": "Tansong Kaban",
  "block.minecraft.copper_door": "Tansong Pinto",
  "block.minecraft.copper_golem_statue": "Estatwang Tansong Golem",
  "block.minecraft.copper_grate": "Tansong Barandilyas",
  "block.minecraft.copper_lantern": "Tansong Paritaan",
  "block.minecraft.copper_ore": "Dukaling Tanso",
  "block.minecraft.copper_torch": "Tansong Sulo",
  "block.minecraft.copper_trapdoor": "Tansong Bukasan",
  "block.minecraft.copper_wall_torch": "Tansong Sulo sa Pader",
  "block.minecraft.cornflower": "Cornflower",
  "block.minecraft.cracked_deepslate_bricks": "May-lamat na Laryong Pisaranlalim",
  "block.minecraft.cracked_deepslate_tiles": "May-lamat na Baldosang Pisaranlalim",
  "block.minecraft.cracked_nether_bricks": "May-lamat na Laryong Nether",
  "block.minecraft.cracked_polished_blackstone_bricks": "May-lamat na Laryong Binulihang Batungitim",
  "block.minecraft.cracked_stone_bricks": "May-lamat na Laryong Bato",
  "block.minecraft.crafter": "Pagawaan",
  "block.minecraft.crafting_table": "Gawaan",
  "block.minecraft.creaking_heart": "Lasgas ng Lumalangitngit",
  "block.minecraft.creeper_head": "Ulo ng Kilabot",
  "block.minecraft.creeper_wall_head": "Ulo ng Creeper sa Pader",
  "block.minecraft.crimson_button": "Krimsong Pindutan",
  "block.minecraft.crimson_door": "Krimsong Pinto",
  "block.minecraft.crimson_fence": "Krimsong Bakod",
  "block.minecraft.crimson_fence_gate": "Krimsong Tarangkahan",
  "block.minecraft.crimson_fungus": "Kabuting Krimson",
  "block.minecraft.crimson_hanging_sign": "Krimsong Karatulang Nakasabit",
  "block.minecraft.crimson_hyphae": "Krimsong Hyphae",
  "block.minecraft.crimson_nylium": "Krimsong Niblayan",
  "block.minecraft.crimson_planks": "Krimsong Tabla",
  "block.minecraft.crimson_pressure_plate": "Krimsong Apakan",
  "block.minecraft.crimson_roots": "Krimsong Ugat",
  "block.minecraft.crimson_shelf": "Krimsong Salansanan",
  "block.minecraft.crimson_sign": "Krimsong Karatula",
  "block.minecraft.crimson_slab": "Krimsong Dalig",
  "block.minecraft.crimson_stairs": "Krimsong Hagdanan",
  "block.minecraft.crimson_stem": "Krimsong Tangkay",
  "block.minecraft.crimson_trapdoor": "Krimsong Bukasan",
  "block.minecraft.crimson_wall_hanging_sign": "Krimsong Karatulang Nakasabit sa Pader",
  "block.minecraft.crimson_wall_sign": "Krimsong Karatula sa Pader",
  "block.minecraft.crying_obsidian": "Lumuluhang Obsidiyana",
  "block.minecraft.cut_copper": "Tinabas na Tanso",
  "block.minecraft.cut_copper_slab": "Tinabas na Tansong Dalig",
  "block.minecraft.cut_copper_stairs": "Tinabas na Tansong Hagdanan",
  "block.minecraft.cut_red_sandstone": "Tinabas na Pulang Batumbuhangin",
  "block.minecraft.cut_red_sandstone_slab": "Tinabas na Pulang Batumbuhanging Dalig",
  "block.minecraft.cut_sandstone": "Tinabas na Batumbuhangin",
  "block.minecraft.cut_sandstone_slab": "Tinabas na Batumbuhanging Dalig",
  "block.minecraft.cyan_banner": "Cyan na Watawat",
  "block.minecraft.cyan_bed": "Cyan na Higaan",
  "block.minecraft.cyan_candle": "Cyan na Sasang",
  "block.minecraft.cyan_candle_cake": "Keyk na may Cyan na Sasang",
  "block.minecraft.cyan_carpet": "Cyan na Banig",
  "block.minecraft.cyan_concrete": "Cyan na Gawambato",
  "block.minecraft.cyan_concrete_powder": "Cyan na Gawambatong Buhangin",
  "block.minecraft.cyan_glazed_terracotta": "Cyan na Sinalaminang Lutunlupa",
  "block.minecraft.cyan_shulker_box": "Cyan na Kahon ng Shulker",
  "block.minecraft.cyan_stained_glass": "Cyan na Salamin",
  "block.minecraft.cyan_stained_glass_pane": "Cyan na Durungawan",
  "block.minecraft.cyan_terracotta": "Cyan na Lutunlupa",
  "block.minecraft.cyan_wool": "Cyan na Lana",
  "block.minecraft.damaged_anvil": "Nasirang Palihan",
  "block.minecraft.dandelion": "Ngiping Leon",
  "block.minecraft.dark_oak_button": "Robleng-dilim na Pindutan",
  "block.minecraft.dark_oak_door": "Robleng-dilim na Pinto",
  "block.minecraft.dark_oak_fence": "Robleng-dilim na Bakod",
  "block.minecraft.dark_oak_fence_gate": "Robleng-dilim na Tarangkahan",
  "block.minecraft.dark_oak_hanging_sign": "Robleng-dilim na Karatulang Nakasabit",
  "block.minecraft.dark_oak_leaves": "Dahon ng Robleng-dilim",
  "block.minecraft.dark_oak_log": "Robleng-dilim na Troso",
  "block.minecraft.dark_oak_planks": "Robleng-dilim na Tabla",
  "block.minecraft.dark_oak_pressure_plate": "Robleng-dilim na Apakan",
  "block.minecraft.dark_oak_sapling": "Punla ng Robleng-dilim",
  "block.minecraft.dark_oak_shelf": "Robleng-dilim na Salansanan",
  "block.minecraft.dark_oak_sign": "Robleng-dilim na Karatula",
  "block.minecraft.dark_oak_slab": "Robleng-dilim na Dalig",
  "block.minecraft.dark_oak_stairs": "Robleng-dilim na Hagdanan",
  "block.minecraft.dark_oak_trapdoor": "Robleng-dilim na Bukasan",
  "block.minecraft.dark_oak_wall_hanging_sign": "Robleng-dilim na Karatulang Nakasabit sa Pader",
  "block.minecraft.dark_oak_wall_sign": "Robleng-dilim na Karatula sa Pader",
  "block.minecraft.dark_oak_wood": "Robleng-dilim na Kahoy",
  "block.minecraft.dark_prismarine": "Maitim na Prismarin",
  "block.minecraft.dark_prismarine_slab": "Maitim na Prismaring Dalig",
  "block.minecraft.dark_prismarine_stairs": "Maitim na Prismaring Hagdanan",
  "block.minecraft.daylight_detector": "Detektor ng Liwanag ng Araw",
  "block.minecraft.dead_brain_coral": "Lamang-paypaysagay sa Pader",
  "block.minecraft.dead_brain_coral_block": "Bloke ng Patay na Lamang-sagay",
  "block.minecraft.dead_brain_coral_fan": "Patay na Lamang-paypaysagay",
  "block.minecraft.dead_brain_coral_wall_fan": "Bloke ng Patay na Lamang-paypaysagay sa Pader",
  "block.minecraft.dead_bubble_coral": "Patay na Bulabulang-sagay",
  "block.minecraft.dead_bubble_coral_block": "Bloke ng Patay na Bulabulang-sagay",
  "block.minecraft.dead_bubble_coral_fan": "Patay na Bulabulang-paypaysagay",
  "block.minecraft.dead_bubble_coral_wall_fan": "Patay na Bulabulang-paypaysagay sa Pader",
  "block.minecraft.dead_bush": "Patay na Palumpong",
  "block.minecraft.dead_fire_coral": "Patay na Alab-sagay",
  "block.minecraft.dead_fire_coral_block": "Bloke ng Patay na Alab-sagay",
  "block.minecraft.dead_fire_coral_fan": "Patay na Alab-paypaysagay",
  "block.minecraft.dead_fire_coral_wall_fan": "Patay na Alab-paypaysagay sa Pader",
  "block.minecraft.dead_horn_coral": "Patay na Sungay-sagay",
  "block.minecraft.dead_horn_coral_block": "Bloke ng Patay na Sungay-sagay",
  "block.minecraft.dead_horn_coral_fan": "Patay na Sungay-paypaysagay",
  "block.minecraft.dead_horn_coral_wall_fan": "Patay na Sungay-paypaysagay sa Pader",
  "block.minecraft.dead_tube_coral": "Patay na Bumbong-sagay",
  "block.minecraft.dead_tube_coral_block": "Bloke ng Patay na Bumbong-sagay",
  "block.minecraft.dead_tube_coral_fan": "Patay na Bumbong-paypaysagay",
  "block.minecraft.dead_tube_coral_wall_fan": "Patay na Bumbong-paypaysagay sa Pader",
  "block.minecraft.decorated_pot": "Pinalamutiang Palayok",
  "block.minecraft.deepslate": "Pisaranlalim",
  "block.minecraft.deepslate_brick_slab": "Laryong Pisaranlalim na Dalig",
  "block.minecraft.deepslate_brick_stairs": "Laryong Pisaranlalim na Hagdanan",
  "block.minecraft.deepslate_brick_wall": "Laryong Pisaranlalim na Pader",
  "block.minecraft.deepslate_bricks": "Laryong Pisaranlalim",
  "block.minecraft.deepslate_coal_ore": "Pisaranlalimang Dukaling Uling",
  "block.minecraft.deepslate_copper_ore": "Pisaranlalimang Dukaling Tanso",
  "block.minecraft.deepslate_diamond_ore": "Pisaranlalimang Dukaling Diyamante",
  "block.minecraft.deepslate_emerald_ore": "Pisaranlalimang Dukaling Esmeralda",
  "block.minecraft.deepslate_gold_ore": "Pisaranlalimang Dukaling Ginto",
  "block.minecraft.deepslate_iron_ore": "Pisaranlalimang Dukaling Bakal",
  "block.minecraft.deepslate_lapis_ore": "Pisaranlalimang Dukaling Lapislasuli",
  "block.minecraft.deepslate_redstone_ore": "Pisaranlalimang Dukaling Redstone",
  "block.minecraft.deepslate_tile_slab": "Baldosang Pisaranlalim na Dalig",
  "block.minecraft.deepslate_tile_stairs": "Baldosang Pisaranlalim na Hagdanan",
  "block.minecraft.deepslate_tile_wall": "Baldosang Pisaranlalim na Pader",
  "block.minecraft.deepslate_tiles": "Baldosang Pisaranlalim",
  "block.minecraft.detector_rail": "Pandamang Daang-bakal",
  "block.minecraft.diamond_block": "Bloke ng Diyamante",
  "block.minecraft.diamond_ore": "Dukaling Diyamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Dioritang Dalig",
  "block.minecraft.diorite_stairs": "Dioritang Hagdanan",
  "block.minecraft.diorite_wall": "Dioritang Pader",
  "block.minecraft.dirt": "Lupa",
  "block.minecraft.dirt_path": "Lupang Pandaanan",
  "block.minecraft.dispenser": "Tagabigay",
  "block.minecraft.dragon_egg": "Itlog ng Bakunawa",
  "block.minecraft.dragon_head": "Ulo ng Bakunawa",
  "block.minecraft.dragon_wall_head": "Ulo ng Bakunawa sa Pader",
  "block.minecraft.dried_ghast": "Tuyong Ghast",
  "block.minecraft.dried_kelp_block": "Bloke ng Tuyong Kelp",
  "block.minecraft.dripstone_block": "Bloke ng Batuntulo",
  "block.minecraft.dropper": "Tagahulog",
  "block.minecraft.emerald_block": "Bloke ng Esmeralda",
  "block.minecraft.emerald_ore": "Dukaling Esmeralda",
  "block.minecraft.enchanting_table": "Hapag-salamangkahan",
  "block.minecraft.end_gateway": "Gateway ng End",
  "block.minecraft.end_portal": "Lagusan sa End",
  "block.minecraft.end_portal_frame": "Balangkas ng Lagusan ng End",
  "block.minecraft.end_rod": "End na Pamalo",
  "block.minecraft.end_stone": "Batong-End",
  "block.minecraft.end_stone_brick_slab": "Laryong Batong-End na Dalig",
  "block.minecraft.end_stone_brick_stairs": "Laryong Batong-End na Hagdanan",
  "block.minecraft.end_stone_brick_wall": "Laryong Batong-End na Pader",
  "block.minecraft.end_stone_bricks": "Laryong Batong-End",
  "block.minecraft.ender_chest": "Kaban na Ender",
  "block.minecraft.exposed_chiseled_copper": "Hayag na Pinaitang Tanso",
  "block.minecraft.exposed_copper": "Hayag na Tanso",
  "block.minecraft.exposed_copper_bars": "Hayag na Tansong Rehas",
  "block.minecraft.exposed_copper_bulb": "Hayag na Tansong Bumbilya",
  "block.minecraft.exposed_copper_chain": "Hayag na Tansong Tanikala",
  "block.minecraft.exposed_copper_chest": "Hayag na Tansong Kaban",
  "block.minecraft.exposed_copper_door": "Hayag na Tansong Pinto",
  "block.minecraft.exposed_copper_golem_statue": "Hayag na Estatwang Tansong Golem",
  "block.minecraft.exposed_copper_grate": "Hayag na Tansong Barandilyas",
  "block.minecraft.exposed_copper_lantern": "Hayag na Tansong Paritaan",
  "block.minecraft.exposed_copper_trapdoor": "Hayag na Tansong Bukasan",
  "block.minecraft.exposed_cut_copper": "Hayag na Tinabas na Tanso",
  "block.minecraft.exposed_cut_copper_slab": "Hayag na Tinabas na Tansong Dalig",
  "block.minecraft.exposed_cut_copper_stairs": "Hayag na Tinabas na Tansong Hagdanan",
  "block.minecraft.exposed_lightning_rod": "Hayag na Kayag-Kidlat",
  "block.minecraft.farmland": "Lupang Sakahin",
  "block.minecraft.fern": "Pako",
  "block.minecraft.fire": "Apoy",
  "block.minecraft.fire_coral": "Alab-sagay",
  "block.minecraft.fire_coral_block": "Bloke ng Alab-sagay",
  "block.minecraft.fire_coral_fan": "Alab-paypaysagay",
  "block.minecraft.fire_coral_wall_fan": "Alab-paypaysagay sa Pader",
  "block.minecraft.firefly_bush": "Palumpong ng Alitaptap",
  "block.minecraft.fletching_table": "Hapag-panaan",
  "block.minecraft.flower_pot": "Paso",
  "block.minecraft.flowering_azalea": "Asaleang Naumumulaklak",
  "block.minecraft.flowering_azalea_leaves": "Dahon ng Asaleang Namumulaklak",
  "block.minecraft.frogspawn": "Itlog ng Palaka",
  "block.minecraft.frosted_ice": "Yelong Andap",
  "block.minecraft.furnace": "Dapugan",
  "block.minecraft.gilded_blackstone": "Ginintuang Batungitim",
  "block.minecraft.glass": "Salamin",
  "block.minecraft.glass_pane": "Durungawan",
  "block.minecraft.glow_lichen": "Kinanging Ligbus",
  "block.minecraft.glowstone": "Batunsinag",
  "block.minecraft.gold_block": "Bloke ng Ginto",
  "block.minecraft.gold_ore": "Dukaling Ginto",
  "block.minecraft.golden_dandelion": "Gintong Ngiping-leon",
  "block.minecraft.granite": "Batumbesi",
  "block.minecraft.granite_slab": "Batumbesi Dalig",
  "block.minecraft.granite_stairs": "Batumbesing Hagdanan",
  "block.minecraft.granite_wall": "Batumbesing Pader",
  "block.minecraft.grass": "Damo",
  "block.minecraft.grass_block": "Bloke ng Damo",
  "block.minecraft.gravel": "Bisil",
  "block.minecraft.gray_banner": "Abong Watawat",
  "block.minecraft.gray_bed": "Abong Higaan",
  "block.minecraft.gray_candle": "Abong Sasang",
  "block.minecraft.gray_candle_cake": "Keyk na may Abong Sasang",
  "block.minecraft.gray_carpet": "Abong Banig",
  "block.minecraft.gray_concrete": "Abong Gawambato",
  "block.minecraft.gray_concrete_powder": "Abong Gawambatong Buhangin",
  "block.minecraft.gray_glazed_terracotta": "Abong Sinalaminang Lutunlupa",
  "block.minecraft.gray_shulker_box": "Abong Kahon ng Shulker",
  "block.minecraft.gray_stained_glass": "Abong Salamin",
  "block.minecraft.gray_stained_glass_pane": "Abong Durungawan",
  "block.minecraft.gray_terracotta": "Abong Lutunlupa",
  "block.minecraft.gray_wool": "Abong Lana",
  "block.minecraft.green_banner": "Lungtiang Watawat",
  "block.minecraft.green_bed": "Lungtiang Higaan",
  "block.minecraft.green_candle": "Lungtiang Sasang",
  "block.minecraft.green_candle_cake": "Keyk na may Lungtiang Sasang",
  "block.minecraft.green_carpet": "Lungtiang Banig",
  "block.minecraft.green_concrete": "Lungtiang Gawambato",
  "block.minecraft.green_concrete_powder": "Lungtiang Gawambatong Buhangin",
  "block.minecraft.green_glazed_terracotta": "Lungtiang Sinalaminang Lutunlupa",
  "block.minecraft.green_shulker_box": "Lungtiang Kahon ng Shulker",
  "block.minecraft.green_stained_glass": "Lungtiang Salamin",
  "block.minecraft.green_stained_glass_pane": "Lungtiang Durungawan",
  "block.minecraft.green_terracotta": "Lungtiang Lutunlupa",
  "block.minecraft.green_wool": "Lungtiang Lana",
  "block.minecraft.grindstone": "Hasaan",
  "block.minecraft.hanging_roots": "Nakabiting Ugat",
  "block.minecraft.hay_block": "Paldo ng Dayami",
  "block.minecraft.heavy_core": "Mabigat na Butod",
  "block.minecraft.heavy_weighted_pressure_plate": "Mabigat na Apakan",
  "block.minecraft.honey_block": "Bloke ng Pulot",
  "block.minecraft.honeycomb_block": "Bloke ng Saray",
  "block.minecraft.hopper": "Lukton",
  "block.minecraft.horn_coral": "Sungay-sagay",
  "block.minecraft.horn_coral_block": "Bloke ng Sungay-sagay",
  "block.minecraft.horn_coral_fan": "Sungay-paypaysagay",
  "block.minecraft.horn_coral_wall_fan": "Sungay-paypaysagay sa Pader",
  "block.minecraft.ice": "Yelo",
  "block.minecraft.infested_chiseled_stone_bricks": "Pinugarang Pinaitang Laryong Bato",
  "block.minecraft.infested_cobblestone": "Pinugarang Batubato",
  "block.minecraft.infested_cracked_stone_bricks": "Pinugarang May-lamat na Laryong Bato",
  "block.minecraft.infested_deepslate": "Pinugarang Pisaranlalim",
  "block.minecraft.infested_mossy_stone_bricks": "Pinugarang Malumot na Laryong Bato",
  "block.minecraft.infested_stone": "Pinugarang Bato",
  "block.minecraft.infested_stone_bricks": "Pinugarang Laryong Bato",
  "block.minecraft.iron_bars": "Bakal na Rehas",
  "block.minecraft.iron_block": "Bloke ng Bakal",
  "block.minecraft.iron_chain": "Bakal na Tanikala",
  "block.minecraft.iron_door": "Bakal na Pinto",
  "block.minecraft.iron_ore": "Dukaling Bakal",
  "block.minecraft.iron_trapdoor": "Bakal na Bukasan",
  "block.minecraft.jack_o_lantern": "Kandos sa Kagabi ng mga Banal",
  "block.minecraft.jigsaw": "Bloke ng Palaisipan",
  "block.minecraft.jukebox": "Musikahon",
  "block.minecraft.jungle_button": "Punonggubat na Pindutan",
  "block.minecraft.jungle_door": "Punonggubat na Pinto",
  "block.minecraft.jungle_fence": "Punonggubat na Bakod",
  "block.minecraft.jungle_fence_gate": "Punonggubat na Tarangkahan",
  "block.minecraft.jungle_hanging_sign": "Punonggubat na Karatulang Nakasabit",
  "block.minecraft.jungle_leaves": "Dahon ng Punonggubat",
  "block.minecraft.jungle_log": "Punonggubat na Troso",
  "block.minecraft.jungle_planks": "Punonggubat na Tabla",
  "block.minecraft.jungle_pressure_plate": "Punonggubat na Apakan",
  "block.minecraft.jungle_sapling": "Punla ng Punonggubat",
  "block.minecraft.jungle_shelf": "Punonggubat na Salansanan",
  "block.minecraft.jungle_sign": "Punonggubat na Karatula",
  "block.minecraft.jungle_slab": "Punonggubat na Dalig",
  "block.minecraft.jungle_stairs": "Punonggubat na Hagdanan",
  "block.minecraft.jungle_trapdoor": "Punonggubat na Bukasan",
  "block.minecraft.jungle_wall_hanging_sign": "Punonggubat na Karatulang Nakasabit sa Pader",
  "block.minecraft.jungle_wall_sign": "Punonggubat na Karatula sa Pader",
  "block.minecraft.jungle_wood": "Punonggubat na Kahoy",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Halamang Kelp",
  "block.minecraft.ladder": "Hagdan",
  "block.minecraft.lantern": "Paritaan",
  "block.minecraft.lapis_block": "Bloke ng Lapislasuli",
  "block.minecraft.lapis_ore": "Dukaling Lapislasuli",
  "block.minecraft.large_amethyst_bud": "Malaking Usbong ng Amatista",
  "block.minecraft.large_fern": "Malaking Pako",
  "block.minecraft.lava": "Kumukulong Putik",
  "block.minecraft.lava_cauldron": "Kaldero ng Kumukulong Putik",
  "block.minecraft.leaf_litter": "Kalat ng Dahon",
  "block.minecraft.lectern": "Patungan ng Aklat",
  "block.minecraft.lever": "Baras",
  "block.minecraft.light": "Ilaw",
  "block.minecraft.light_blue_banner": "Langit na Watawat",
  "block.minecraft.light_blue_bed": "Langit na Higaan",
  "block.minecraft.light_blue_candle": "Langit na Sasang",
  "block.minecraft.light_blue_candle_cake": "Keyk na may Langit na Sasang",
  "block.minecraft.light_blue_carpet": "Langit na Banig",
  "block.minecraft.light_blue_concrete": "Langit na Gawambato",
  "block.minecraft.light_blue_concrete_powder": "Langit na Gawambatong Buhangin",
  "block.minecraft.light_blue_glazed_terracotta": "Langit na Sinalaminang Lutunlupa",
  "block.minecraft.light_blue_shulker_box": "Langit na Kahon ng Shulker",
  "block.minecraft.light_blue_stained_glass": "Langit na Salamin",
  "block.minecraft.light_blue_stained_glass_pane": "Langit na Durungawan",
  "block.minecraft.light_blue_terracotta": "Langit na Lutunlupa",
  "block.minecraft.light_blue_wool": "Langit na Lana",
  "block.minecraft.light_gray_banner": "Pilak na Watawat",
  "block.minecraft.light_gray_bed": "Pilak na Higaan",
  "block.minecraft.light_gray_candle": "Pilak na Sasang",
  "block.minecraft.light_gray_candle_cake": "Keyk na may Pilak na Sasang",
  "block.minecraft.light_gray_carpet": "Pilak na Banig",
  "block.minecraft.light_gray_concrete": "Pilak na Gawambato",
  "block.minecraft.light_gray_concrete_powder": "Pilak na Gawambatong Buhangin",
  "block.minecraft.light_gray_glazed_terracotta": "Pilak na Sinalaminang Lutunlupa",
  "block.minecraft.light_gray_shulker_box": "Pilak na Kahon ng Shulker",
  "block.minecraft.light_gray_stained_glass": "Pilak na Salamin",
  "block.minecraft.light_gray_stained_glass_pane": "Pilak na Durungawan",
  "block.minecraft.light_gray_terracotta": "Pilak na Lutunlupa",
  "block.minecraft.light_gray_wool": "Pilak na Lana",
  "block.minecraft.light_weighted_pressure_plate": "Magaang Apakan",
  "block.minecraft.lightning_rod": "Kayag-Kidlat",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Liryo ng Lambak",
  "block.minecraft.lily_pad": "Dahon ng Liryo",
  "block.minecraft.lime_banner": "Dayap na Watawat",
  "block.minecraft.lime_bed": "Dayap na Higaan",
  "block.minecraft.lime_candle": "Dayap na Sasang",
  "block.minecraft.lime_candle_cake": "Keyk na may Dayap na Sasang",
  "block.minecraft.lime_carpet": "Dayap na Banig",
  "block.minecraft.lime_concrete": "Dayap na Gawambato",
  "block.minecraft.lime_concrete_powder": "Dayap na Gawambatong Buhangin",
  "block.minecraft.lime_glazed_terracotta": "Dayap na Sinalaminang Lutunlupa",
  "block.minecraft.lime_shulker_box": "Dayap na Kahon ng Shulker",
  "block.minecraft.lime_stained_glass": "Dayap na Salamin",
  "block.minecraft.lime_stained_glass_pane": "Dayap na Durungawan",
  "block.minecraft.lime_terracotta": "Dayap na Lutunlupa",
  "block.minecraft.lime_wool": "Dayap na Lana",
  "block.minecraft.lodestone": "Batubalani",
  "block.minecraft.loom": "Habihan",
  "block.minecraft.magenta_banner": "Mahentang Watawat",
  "block.minecraft.magenta_bed": "Mahentang Higaan",
  "block.minecraft.magenta_candle": "Mahentang Sasang",
  "block.minecraft.magenta_candle_cake": "Keyk na may Mahentang Sasang",
  "block.minecraft.magenta_carpet": "Mahentang Banig",
  "block.minecraft.magenta_concrete": "Mahentang Gawambato",
  "block.minecraft.magenta_concrete_powder": "Mahentang Gawambatong Buhangin",
  "block.minecraft.magenta_glazed_terracotta": "Mahentang Sinalaminang Lutunlupa",
  "block.minecraft.magenta_shulker_box": "Mahentang Kahon ng Shulker",
  "block.minecraft.magenta_stained_glass": "Mahentang Salamin",
  "block.minecraft.magenta_stained_glass_pane": "Mahentang Durungawan",
  "block.minecraft.magenta_terracotta": "Mahentang Lutunlupa",
  "block.minecraft.magenta_wool": "Mahentang Lana",
  "block.minecraft.magma_block": "Bloke ng Magma",
  "block.minecraft.mangrove_button": "Bakawang Pindutan",
  "block.minecraft.mangrove_door": "Bakawang Pinto",
  "block.minecraft.mangrove_fence": "Bakawang Bakod",
  "block.minecraft.mangrove_fence_gate": "Bakawang Tarangkahan",
  "block.minecraft.mangrove_hanging_sign": "Bakawang Karatulang Nakasabit",
  "block.minecraft.mangrove_leaves": "Dahon ng Bakawan",
  "block.minecraft.mangrove_log": "Bakawang Troso",
  "block.minecraft.mangrove_planks": "Bakawang Tabla",
  "block.minecraft.mangrove_pressure_plate": "Bakawang Apakan",
  "block.minecraft.mangrove_propagule": "Binhi ng Bakawan",
  "block.minecraft.mangrove_roots": "Ugat ng Bakawan",
  "block.minecraft.mangrove_shelf": "Bakawang Salansanan",
  "block.minecraft.mangrove_sign": "Bakawang Karatula",
  "block.minecraft.mangrove_slab": "Bakawang Dalig",
  "block.minecraft.mangrove_stairs": "Bakawang Hagdanan",
  "block.minecraft.mangrove_trapdoor": "Bakawang Bukasan",
  "block.minecraft.mangrove_wall_hanging_sign": "Bakawang Karatulang Nakasabit sa Pader",
  "block.minecraft.mangrove_wall_sign": "Bakawang Karatula sa Pader",
  "block.minecraft.mangrove_wood": "Bakawang Kahoy",
  "block.minecraft.medium_amethyst_bud": "Katamtamang Usbong ng Amatista",
  "block.minecraft.melon": "Pakwan",
  "block.minecraft.melon_stem": "Tangkay ng Pakwan",
  "block.minecraft.moss_block": "Bloke ng Lumot",
  "block.minecraft.moss_carpet": "Lumot na Banig",
  "block.minecraft.mossy_cobblestone": "May-lamat na Malumot na Batubato",
  "block.minecraft.mossy_cobblestone_slab": "Malumot na Batubatong Dalig",
  "block.minecraft.mossy_cobblestone_stairs": "Malumot na Batubatong Hagdanan",
  "block.minecraft.mossy_cobblestone_wall": "Malumot na Batubatong Pader",
  "block.minecraft.mossy_stone_brick_slab": "Malumot na Laryong Batong-dalig",
  "block.minecraft.mossy_stone_brick_stairs": "Malumot na Laryong Batong Hagdanan",
  "block.minecraft.mossy_stone_brick_wall": "Malumot na Laryong Batong Pader",
  "block.minecraft.mossy_stone_bricks": "Malumot na Laryong Bato",
  "block.minecraft.moving_piston": "Gumagalaw na Piston",
  "block.minecraft.mud": "Putik",
  "block.minecraft.mud_brick_slab": "Laryong Putik na Dalig",
  "block.minecraft.mud_brick_stairs": "Laryong Putik na Hagdanan",
  "block.minecraft.mud_brick_wall": "Laryong Putik na Pader",
  "block.minecraft.mud_bricks": "Laryong Putik",
  "block.minecraft.muddy_mangrove_roots": "Maputik na Ugat ng Bakawan",
  "block.minecraft.mushroom_stem": "Tangkay ng Kabute",
  "block.minecraft.mycelium": "Sanghiblayan",
  "block.minecraft.nether_brick_fence": "Laryong Nether na Bakod",
  "block.minecraft.nether_brick_slab": "Laryong Nether na Dalig",
  "block.minecraft.nether_brick_stairs": "Laryong Nether na Hagdanan",
  "block.minecraft.nether_brick_wall": "Laryong Nether na Pader",
  "block.minecraft.nether_bricks": "Laryong Nether",
  "block.minecraft.nether_gold_ore": "Dukaling Gintong-Nether",
  "block.minecraft.nether_portal": "Lagusan ng Nether",
  "block.minecraft.nether_quartz_ore": "Dukaling Kinyang-Nether",
  "block.minecraft.nether_sprouts": "Usbong na Nether",
  "block.minecraft.nether_wart": "Butig na Nether",
  "block.minecraft.nether_wart_block": "Bloke ng Butig na Nether",
  "block.minecraft.netherite_block": "Bloke ng Netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloke ng Nota",
  "block.minecraft.oak_button": "Robleng Pindutan",
  "block.minecraft.oak_door": "Robleng Pinto",
  "block.minecraft.oak_fence": "Robleng Bakod",
  "block.minecraft.oak_fence_gate": "Robleng Tarangkahan",
  "block.minecraft.oak_hanging_sign": "Robleng Karatulang Nakasabit",
  "block.minecraft.oak_leaves": "Dahon ng Roble",
  "block.minecraft.oak_log": "Robleng Troso",
  "block.minecraft.oak_planks": "Robleng Tabla",
  "block.minecraft.oak_pressure_plate": "Robleng Apakan",
  "block.minecraft.oak_sapling": "Punla ng Roble",
  "block.minecraft.oak_shelf": "Robleng Salansanan",
  "block.minecraft.oak_sign": "Robleng Karatula",
  "block.minecraft.oak_slab": "Robleng Dalig",
  "block.minecraft.oak_stairs": "Robleng Hagdanan",
  "block.minecraft.oak_trapdoor": "Robleng Bukasan",
  "block.minecraft.oak_wall_hanging_sign": "Robleng Karatulang Nakasabit sa Pader",
  "block.minecraft.oak_wall_sign": "Robleng Karatula sa Pader",
  "block.minecraft.oak_wood": "Robleng Kahoy",
  "block.minecraft.observer": "Tagamasid",
  "block.minecraft.obsidian": "Obsidiyana",
  "block.minecraft.ochre_froglight": "Okreng Palakanag",
  "block.minecraft.ominous_banner": "Nakakatakot na Watawat",
  "block.minecraft.open_eyeblossom": "Mulat na Matambulak",
  "block.minecraft.orange_banner": "Bulantubig na Watawat",
  "block.minecraft.orange_bed": "Bulantubig na Higaan",
  "block.minecraft.orange_candle": "Bulantubig na Sasang",
  "block.minecraft.orange_candle_cake": "Keyk na may Bulantubig na Sasang",
  "block.minecraft.orange_carpet": "Bulantubig na Banig",
  "block.minecraft.orange_concrete": "Bulantubig na Gawambato",
  "block.minecraft.orange_concrete_powder": "Bulantubig na Gawambatong Buhangin",
  "block.minecraft.orange_glazed_terracotta": "Bulantubig na Sinalaminang Lutunlupa",
  "block.minecraft.orange_shulker_box": "Bulantubig na Kahon ng Shulker",
  "block.minecraft.orange_stained_glass": "Bulantubig na Salamin",
  "block.minecraft.orange_stained_glass_pane": "Bulantubig na Durungawan",
  "block.minecraft.orange_terracotta": "Bulantubig na Lutunlupa",
  "block.minecraft.orange_tulip": "Tulipang Bulantubig",
  "block.minecraft.orange_wool": "Bulantubig na Lana",
  "block.minecraft.oxeye_daisy": "Oxeye na Daisy",
  "block.minecraft.oxidized_chiseled_copper": "Nasadagisik na Pinaitang Tanso",
  "block.minecraft.oxidized_copper": "Nasadagisik na Tanso",
  "block.minecraft.oxidized_copper_bars": "Nasadagisik na Tansong Rehas",
  "block.minecraft.oxidized_copper_bulb": "Nasadagisik na Tansong Bumbilya",
  "block.minecraft.oxidized_copper_chain": "Nasadagisik na Tansong Tanikala",
  "block.minecraft.oxidized_copper_chest": "Nasadagisik na Tansong Kaban",
  "block.minecraft.oxidized_copper_door": "Nasadagisik na Tansong Pinto",
  "block.minecraft.oxidized_copper_golem_statue": "Nasadagisik na Estatwang Tansong Golem",
  "block.minecraft.oxidized_copper_grate": "Nasadagisik na Tansong Barandilyas",
  "block.minecraft.oxidized_copper_lantern": "Nasadagisik na Tansong Paritaan",
  "block.minecraft.oxidized_copper_trapdoor": "Nasadagisik na Tansong Bukasan",
  "block.minecraft.oxidized_cut_copper": "Nasadagisik na Tinabas Tanso",
  "block.minecraft.oxidized_cut_copper_slab": "Nasadagisik na Tinabas na Tansong Dalig",
  "block.minecraft.oxidized_cut_copper_stairs": "Nasadagisik na Tinabas na Tansong Hagdanan",
  "block.minecraft.oxidized_lightning_rod": "Nasadigisik na Kayag-Kidlat",
  "block.minecraft.packed_ice": "Siniksik na Yelo",
  "block.minecraft.packed_mud": "Sinisik na Putik",
  "block.minecraft.pale_hanging_moss": "Maputlang Nakalawit na Lumot",
  "block.minecraft.pale_moss_block": "Bloke ng Maputlang Lumot",
  "block.minecraft.pale_moss_carpet": "Maputlang Lumot na Banig",
  "block.minecraft.pale_oak_button": "Robleng-putlang Pindutan",
  "block.minecraft.pale_oak_door": "Robleng-putlang Pinto",
  "block.minecraft.pale_oak_fence": "Robleng-putlang Bakod",
  "block.minecraft.pale_oak_fence_gate": "Robleng-putlang Tarangkahan",
  "block.minecraft.pale_oak_hanging_sign": "Robleng-putlang Karatulang Nakasabit",
  "block.minecraft.pale_oak_leaves": "Dahon ng Robleng-putla",
  "block.minecraft.pale_oak_log": "Robleng-putlang Pinto",
  "block.minecraft.pale_oak_planks": "Robleng-putlang Tabla",
  "block.minecraft.pale_oak_pressure_plate": "Robleng-putlang Apakan",
  "block.minecraft.pale_oak_sapling": "Punla ng Robleng-putla",
  "block.minecraft.pale_oak_shelf": "Robleng-putlang Salansanan",
  "block.minecraft.pale_oak_sign": "Robleng-putlang Karatula",
  "block.minecraft.pale_oak_slab": "Robleng-putlang Dalig",
  "block.minecraft.pale_oak_stairs": "Robleng-putlang Hagdanan",
  "block.minecraft.pale_oak_trapdoor": "Robleng-putlang Bukasan",
  "block.minecraft.pale_oak_wall_hanging_sign": "Robleng-putlang Karatulang Nakasabit sa Pader",
  "block.minecraft.pale_oak_wall_sign": "Robleng-putlang Karatula sa Pader",
  "block.minecraft.pale_oak_wood": "Robleng-putlang Kahoy",
  "block.minecraft.pearlescent_froglight": "Malamutyang Palakanag",
  "block.minecraft.peony": "Peoni",
  "block.minecraft.petrified_oak_slab": "Nanigas na Robleng Dalig",
  "block.minecraft.piglin_head": "Ulo ng Piglin",
  "block.minecraft.piglin_wall_head": "Ulo ng Piglin sa Pader",
  "block.minecraft.pink_banner": "Kalimbahing Watawat",
  "block.minecraft.pink_bed": "Kalimbahing Higaan",
  "block.minecraft.pink_candle": "Kalimbahing Sasang",
  "block.minecraft.pink_candle_cake": "Keyk na may Kalimbahing Sasang",
  "block.minecraft.pink_carpet": "Kalimbahing Banig",
  "block.minecraft.pink_concrete": "Kalimbahing Gawambato",
  "block.minecraft.pink_concrete_powder": "Kalimbahing Gawambatong Buhangin",
  "block.minecraft.pink_glazed_terracotta": "Kalimbahing Sinalaminang Lutunlupa",
  "block.minecraft.pink_petals": "Rosas-talulot",
  "block.minecraft.pink_shulker_box": "Kalimbahing Kahon ng Shulker",
  "block.minecraft.pink_stained_glass": "Kalimbahing Salamin",
  "block.minecraft.pink_stained_glass_pane": "Kalimbahing Durungawan",
  "block.minecraft.pink_terracotta": "Kalimbahing Lutunlupa",
  "block.minecraft.pink_tulip": "Kalimbahing Tulip",
  "block.minecraft.pink_wool": "Kalimbahing Lana",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Ulo ng Piston",
  "block.minecraft.pitcher_crop": "Pananim na Pitsel-pitsel",
  "block.minecraft.pitcher_plant": "Pitsel-pitsel",
  "block.minecraft.player_head": "Ulo ng Manlalaro",
  "block.minecraft.player_head.named": "Ulo ni %s",
  "block.minecraft.player_wall_head": "Ulo ng Manlalaro sa Pader",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Matulis na Batuntulo",
  "block.minecraft.polished_andesite": "Binulihang Andesita",
  "block.minecraft.polished_andesite_slab": "Binulihang Andesitang Dalig",
  "block.minecraft.polished_andesite_stairs": "Binulihang Andesitang Hagdanan",
  "block.minecraft.polished_basalt": "Binulihang Batumbakal",
  "block.minecraft.polished_blackstone": "Binulihang Batungitim",
  "block.minecraft.polished_blackstone_brick_slab": "Laryong Binulihang Batungitim na Dalig",
  "block.minecraft.polished_blackstone_brick_stairs": "Laryong Binulihang Batungitim na Hagdanan",
  "block.minecraft.polished_blackstone_brick_wall": "Laryong Binulihang Batungitim na Pader",
  "block.minecraft.polished_blackstone_bricks": "Laryong Binulihang Batungitim",
  "block.minecraft.polished_blackstone_button": "Binulihang Batungitim na Pindutan",
  "block.minecraft.polished_blackstone_pressure_plate": "Binulihang Batungitim na Apakan",
  "block.minecraft.polished_blackstone_slab": "Binulihang Batungitim na Dalig",
  "block.minecraft.polished_blackstone_stairs": "Binulihang Batungitim na Hagdanan",
  "block.minecraft.polished_blackstone_wall": "Binulihang Batungitim na Pader",
  "block.minecraft.polished_deepslate": "Binulihang Pisaranlalim",
  "block.minecraft.polished_deepslate_slab": "Binulihang Pisaranlalim na Dalig",
  "block.minecraft.polished_deepslate_stairs": "Binulihang Batungitim na Hagdanan",
  "block.minecraft.polished_deepslate_wall": "Binulihang Pisaranlalim na Pader",
  "block.minecraft.polished_diorite": "Binulihang Diorita",
  "block.minecraft.polished_diorite_slab": "Binulihang Dioritang Dalig",
  "block.minecraft.polished_diorite_stairs": "Binulihang Dioritang Hagdanan",
  "block.minecraft.polished_granite": "Binulihang Batumbesi",
  "block.minecraft.polished_granite_slab": "Binulihang Batumbesing Dalig",
  "block.minecraft.polished_granite_stairs": "Binulihang Batumbesing Hagdanan",
  "block.minecraft.polished_tuff": "Binulihang Tupo",
  "block.minecraft.polished_tuff_slab": "Binulihang Tupong Dalig",
  "block.minecraft.polished_tuff_stairs": "Binulihang Tupong Hagdanan",
  "block.minecraft.polished_tuff_wall": "Binulihang Tupong Pader",
  "block.minecraft.poppy": "Amapola",
  "block.minecraft.potatoes": "Mga Abukot",
  "block.minecraft.potted_acacia_sapling": "Nakapasong Punla ng Langil",
  "block.minecraft.potted_allium": "Nakapasong Allium",
  "block.minecraft.potted_azalea_bush": "Nakapasong Asalea",
  "block.minecraft.potted_azure_bluet": "Nakapasong Bughaw na Ligaw na Bulaklak",
  "block.minecraft.potted_bamboo": "Nakapasong Kawayan",
  "block.minecraft.potted_birch_sapling": "Nakapasong Punla ng Abedul",
  "block.minecraft.potted_blue_orchid": "Nakapasong Bughaw na Orkidia",
  "block.minecraft.potted_brown_mushroom": "Nakapasong Kayumangging Kabute",
  "block.minecraft.potted_cactus": "Nakapasong Kakto",
  "block.minecraft.potted_cherry_sapling": "Nakapasong Punla ng Sakura",
  "block.minecraft.potted_closed_eyeblossom": "Nakapasong Pikit na Matambulak",
  "block.minecraft.potted_cornflower": "Nakapasong Cornflower",
  "block.minecraft.potted_crimson_fungus": "Nakapasong Kabuting Krimson",
  "block.minecraft.potted_crimson_roots": "Nakapasong Krimsong Ugat",
  "block.minecraft.potted_dandelion": "Nakapasong Ngiping Leon",
  "block.minecraft.potted_dark_oak_sapling": "Nakapasong Punla ng Robleng-dilim",
  "block.minecraft.potted_dead_bush": "Nakapasong Patay na Palumpong",
  "block.minecraft.potted_fern": "Nakapasong Pako",
  "block.minecraft.potted_flowering_azalea_bush": "Nakapasong Asaleang Namumulaklak",
  "block.minecraft.potted_golden_dandelion": "Nakapasong Gintong Ngiping-leon",
  "block.minecraft.potted_jungle_sapling": "Nakapasong Punla ng Punonggubat",
  "block.minecraft.potted_lily_of_the_valley": "Nakapasong Liryo ng Lambak",
  "block.minecraft.potted_mangrove_propagule": "Nakapasong Binhi ng Bakawan",
  "block.minecraft.potted_oak_sapling": "Nakapasong Punla ng Roble",
  "block.minecraft.potted_open_eyeblossom": "Nakapasong Mulat na Matambulak",
  "block.minecraft.potted_orange_tulip": "Nakapasong Tulipang Bulantubig",
  "block.minecraft.potted_oxeye_daisy": "Nakapasong Oxeye na Daisy",
  "block.minecraft.potted_pale_oak_sapling": "Nakapasong Punla ng Robleng-putla",
  "block.minecraft.potted_pink_tulip": "Nakapasong Kalimbahing Tulip",
  "block.minecraft.potted_poppy": "Nakapasong Amapola",
  "block.minecraft.potted_red_mushroom": "Nakapasong Pulang Kabute",
  "block.minecraft.potted_red_tulip": "Nakapasong Tulipang Pula",
  "block.minecraft.potted_spruce_sapling": "Nakapasong Punla ng Sahing",
  "block.minecraft.potted_torchflower": "Nakapasong Sulumbulak",
  "block.minecraft.potted_warped_fungus": "Nakapasong Kiwal na Kabuti",
  "block.minecraft.potted_warped_roots": "Nakapasong Kiwal na Ugat",
  "block.minecraft.potted_white_tulip": "Nakapasong Tulipang Puti",
  "block.minecraft.potted_wither_rose": "Nakapasong Rosas ng Wither",
  "block.minecraft.powder_snow": "Niyebeng-pulbos",
  "block.minecraft.powder_snow_cauldron": "Kaldero ng Niyebeng-pulbos",
  "block.minecraft.powered_rail": "Pantakbong Daang-bakal",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Laryong Prismaring Dalig",
  "block.minecraft.prismarine_brick_stairs": "Laryong Prismaring Hagdanan",
  "block.minecraft.prismarine_bricks": "Laryong Prismarin",
  "block.minecraft.prismarine_slab": "Prismaring Dalig",
  "block.minecraft.prismarine_stairs": "Prismaring Hagdanan",
  "block.minecraft.prismarine_wall": "Prismaring Pader",
  "block.minecraft.pumpkin": "Kandos",
  "block.minecraft.pumpkin_stem": "Tangkay ng Kandos",
  "block.minecraft.purple_banner": "Habang Watawat",
  "block.minecraft.purple_bed": "Habang Higaan",
  "block.minecraft.purple_candle": "Habang Sasang",
  "block.minecraft.purple_candle_cake": "Keyk na may Habang Sasang",
  "block.minecraft.purple_carpet": "Habang Banig",
  "block.minecraft.purple_concrete": "Habang Gawambato",
  "block.minecraft.purple_concrete_powder": "Habang Gawambatong Buhangin",
  "block.minecraft.purple_glazed_terracotta": "Habang Sinalaminang Lutunlupa",
  "block.minecraft.purple_shulker_box": "Habang Kahon ng Shulker",
  "block.minecraft.purple_stained_glass": "Habang Salamin",
  "block.minecraft.purple_stained_glass_pane": "Habang Durungawan",
  "block.minecraft.purple_terracotta": "Habang Lutunlupa",
  "block.minecraft.purple_wool": "Habang Lana",
  "block.minecraft.purpur_block": "Bloke ng Purpur",
  "block.minecraft.purpur_pillar": "Purpur na Haligi",
  "block.minecraft.purpur_slab": "Purpur na Dalig",
  "block.minecraft.purpur_stairs": "Purpur na Hagdanan",
  "block.minecraft.quartz_block": "Bloke ng Kinyang",
  "block.minecraft.quartz_bricks": "Laryong Kinyang",
  "block.minecraft.quartz_pillar": "Kinyang na Haligi",
  "block.minecraft.quartz_slab": "Kinyang na Dalig",
  "block.minecraft.quartz_stairs": "Kinyang na Hagdanan",
  "block.minecraft.rail": "Daang-bakal",
  "block.minecraft.raw_copper_block": "Block ng Hilaw na Tanso",
  "block.minecraft.raw_gold_block": "Bloke ng Hilaw na Ginto",
  "block.minecraft.raw_iron_block": "Bloke ng Hilaw na Bakal",
  "block.minecraft.red_banner": "Pulang Watawat",
  "block.minecraft.red_bed": "Pulang Higaan",
  "block.minecraft.red_candle": "Pulang Sasang",
  "block.minecraft.red_candle_cake": "Keyk na may Pulang Sasang",
  "block.minecraft.red_carpet": "Pulang Banig",
  "block.minecraft.red_concrete": "Pulang Gawambato",
  "block.minecraft.red_concrete_powder": "Pulang Gawambatong Buhangin",
  "block.minecraft.red_glazed_terracotta": "Pulang Sinalaminang Lutunlupa",
  "block.minecraft.red_mushroom": "Pulang Kabute",
  "block.minecraft.red_mushroom_block": "Bloke ng Pulang Kabute",
  "block.minecraft.red_nether_brick_slab": "Pulang Laryong Nether na Dalig",
  "block.minecraft.red_nether_brick_stairs": "Pulang Laryong Nether na Hagdanan",
  "block.minecraft.red_nether_brick_wall": "Pulang Laryong Nether na Pader",
  "block.minecraft.red_nether_bricks": "Pulang Laryong Nether",
  "block.minecraft.red_sand": "Pulang Buhangin",
  "block.minecraft.red_sandstone": "Pulang Batumbuhangin",
  "block.minecraft.red_sandstone_slab": "Pulang Batumbuhanging Dalig",
  "block.minecraft.red_sandstone_stairs": "Pulang Batumbuhanging Hagdanan",
  "block.minecraft.red_sandstone_wall": "Pulang Batumbuhanging Pader",
  "block.minecraft.red_shulker_box": "Pulang Kahon ng Shulker",
  "block.minecraft.red_stained_glass": "Pulang Salamin",
  "block.minecraft.red_stained_glass_pane": "Pulang Durungawan",
  "block.minecraft.red_terracotta": "Pulang Lutunlupa",
  "block.minecraft.red_tulip": "Tulipang Pula",
  "block.minecraft.red_wool": "Pulang Lana",
  "block.minecraft.redstone_block": "Bloke ng Redstone",
  "block.minecraft.redstone_lamp": "Redstone na Ilawan",
  "block.minecraft.redstone_ore": "Dukaling Redstone",
  "block.minecraft.redstone_torch": "Sulong Redstone",
  "block.minecraft.redstone_wall_torch": "Sulong Redstone sa Pader",
  "block.minecraft.redstone_wire": "Redstone na Kawad",
  "block.minecraft.reinforced_deepslate": "Pinatibay na Pisaranlalim",
  "block.minecraft.repeater": "Redstone Pang-ulit",
  "block.minecraft.repeating_command_block": "Paulit na Bloke ng Utos",
  "block.minecraft.resin_block": "Bloke ng Dagta",
  "block.minecraft.resin_brick_slab": "Laryong Dagtang Dalig",
  "block.minecraft.resin_brick_stairs": "Laryong Dagtang Hagdanan",
  "block.minecraft.resin_brick_wall": "Laryong Dagtang Pader",
  "block.minecraft.resin_bricks": "Laryong Dagta",
  "block.minecraft.resin_clump": "Kumpol ng Dagta",
  "block.minecraft.respawn_anchor": "Sawo ng Muling-Litawan",
  "block.minecraft.rooted_dirt": "Lupang Maugat",
  "block.minecraft.rose_bush": "Rosal",
  "block.minecraft.sand": "Buhangin",
  "block.minecraft.sandstone": "Batumbuhangin",
  "block.minecraft.sandstone_slab": "Batumbuhanging Dalig",
  "block.minecraft.sandstone_stairs": "Batumbuhanging Hagdanan",
  "block.minecraft.sandstone_wall": "Batumbuhanging Pader",
  "block.minecraft.scaffolding": "Patungan",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Pangganapbilusang Sculk",
  "block.minecraft.sculk_sensor": "Panandamang Sculk",
  "block.minecraft.sculk_shrieker": "Panghiyawang Sculk",
  "block.minecraft.sculk_vein": "Ugat ng Sculk",
  "block.minecraft.sea_lantern": "Paritaang Dagat",
  "block.minecraft.sea_pickle": "Atsarang Dagat",
  "block.minecraft.seagrass": "Damong-dagat",
  "block.minecraft.set_spawn": "Itinakda ang punto ng muling-litawan",
  "block.minecraft.short_dry_grass": "Maikling Tuyong Damo",
  "block.minecraft.short_grass": "Maikling Damo",
  "block.minecraft.shroomlight": "Kabuteng-ilaw",
  "block.minecraft.shulker_box": "Kahon ng Shulker",
  "block.minecraft.skeleton_skull": "Bungo ng Kalansay",
  "block.minecraft.skeleton_wall_skull": "Bungo ng Kalansay sa Pader",
  "block.minecraft.slime_block": "Bloke ng Lusak",
  "block.minecraft.small_amethyst_bud": "Maliit na Usbong ng Amatista",
  "block.minecraft.small_dripleaf": "Maliit na Tulundahon",
  "block.minecraft.smithing_table": "Hapag-pandayan",
  "block.minecraft.smoker": "Usukan",
  "block.minecraft.smooth_basalt": "Makinis na Batumbakal",
  "block.minecraft.smooth_quartz": "Bloke ng Makinis na Kinyang",
  "block.minecraft.smooth_quartz_slab": "Makinis na Kinyang na Dalig",
  "block.minecraft.smooth_quartz_stairs": "Makinis na Kinyang na Hagdanan",
  "block.minecraft.smooth_red_sandstone": "Makinis na Pulang Batumbuhangin",
  "block.minecraft.smooth_red_sandstone_slab": "Makinis na Pulang Batumbuhanging Dalig",
  "block.minecraft.smooth_red_sandstone_stairs": "Makinis na Pulang Batumbuhanging Hagdanan",
  "block.minecraft.smooth_sandstone": "Makinis na Batumbuhangin",
  "block.minecraft.smooth_sandstone_slab": "Makinis na Batumbuhanging Dalig",
  "block.minecraft.smooth_sandstone_stairs": "Makinis na Batumbuhanging Hagdan",
  "block.minecraft.smooth_stone": "Makinis na Bato",
  "block.minecraft.smooth_stone_slab": "Makinis na Batong-dalig",
  "block.minecraft.sniffer_egg": "Itlog ng Palasinghot",
  "block.minecraft.snow": "Niyebe",
  "block.minecraft.snow_block": "Bloke ng Niyebe",
  "block.minecraft.soul_campfire": "Kaluluwang Siga",
  "block.minecraft.soul_fire": "Kaluluwang Apoy",
  "block.minecraft.soul_lantern": "Kaluluwang Paritaan",
  "block.minecraft.soul_sand": "Kaluluwang Buhangin",
  "block.minecraft.soul_soil": "Kaluluwang Lupa",
  "block.minecraft.soul_torch": "Kaluluwang Sulo",
  "block.minecraft.soul_wall_torch": "Kaluluwang Sulo sa Pader",
  "block.minecraft.spawn.not_valid": "Wala kang higaan o nakakargang sawo ng muling-litawan, o naharangan ito",
  "block.minecraft.spawner": "Likhaan ng Halimaw",
  "block.minecraft.spawner.desc1": "Kapag ginamitan ng Panlikhaang Itlog:",
  "block.minecraft.spawner.desc2": "Itinatakda ang Uri ng Nilalang",
  "block.minecraft.sponge": "Espongha",
  "block.minecraft.spore_blossom": "Esporambulak",
  "block.minecraft.spruce_button": "Sahing na Pindutan",
  "block.minecraft.spruce_door": "Sahing na Pinto",
  "block.minecraft.spruce_fence": "Sahing na Bakod",
  "block.minecraft.spruce_fence_gate": "Sahing na Tarangkahan",
  "block.minecraft.spruce_hanging_sign": "Sahing na Karatulang Nakasabit",
  "block.minecraft.spruce_leaves": "Dahon ng Sahing",
  "block.minecraft.spruce_log": "Sahing na Troso",
  "block.minecraft.spruce_planks": "Sahing na Tabla",
  "block.minecraft.spruce_pressure_plate": "Sahing na Apakan",
  "block.minecraft.spruce_sapling": "Punla ng Sahing",
  "block.minecraft.spruce_shelf": "Sahing na Salansanan",
  "block.minecraft.spruce_sign": "Sahing na Karatula",
  "block.minecraft.spruce_slab": "Sahing na Dalig",
  "block.minecraft.spruce_stairs": "Sahing na Hagdanan",
  "block.minecraft.spruce_trapdoor": "Sahing na Bukasan",
  "block.minecraft.spruce_wall_hanging_sign": "Sahing na Karatulang Nakasabit sa Pader",
  "block.minecraft.spruce_wall_sign": "Sahing na Karatula sa Pader",
  "block.minecraft.spruce_wood": "Sahing na Kahoy",
  "block.minecraft.sticky_piston": "Pistong Malagkit",
  "block.minecraft.stone": "Bato",
  "block.minecraft.stone_brick_slab": "Laryong Batong-dalig",
  "block.minecraft.stone_brick_stairs": "Laryong Batong Hagdanan",
  "block.minecraft.stone_brick_wall": "Laryong Batong Pader",
  "block.minecraft.stone_bricks": "Laryong Bato",
  "block.minecraft.stone_button": "Batong Pindutan",
  "block.minecraft.stone_pressure_plate": "Apakan na Bato",
  "block.minecraft.stone_slab": "Batong-dalig",
  "block.minecraft.stone_stairs": "Batong Hagdanan",
  "block.minecraft.stonecutter": "Pamutol ng Bato",
  "block.minecraft.stripped_acacia_log": "Binalatang Langil na Troso",
  "block.minecraft.stripped_acacia_wood": "Binalatang Langil na Kahoy",
  "block.minecraft.stripped_bamboo_block": "Bloke ng Binalatang Kawayan",
  "block.minecraft.stripped_birch_log": "Binalatang Abedul na Troso",
  "block.minecraft.stripped_birch_wood": "Binalatang Abedul na Kahoy",
  "block.minecraft.stripped_cherry_log": "Binalatang Sakurang Troso",
  "block.minecraft.stripped_cherry_wood": "Binalatang Sakurang Kahoy",
  "block.minecraft.stripped_crimson_hyphae": "Binalatang Krimsong Hyphae",
  "block.minecraft.stripped_crimson_stem": "Binalatang Krimsong Tangkay",
  "block.minecraft.stripped_dark_oak_log": "Binalatang Robleng-dilim na Troso",
  "block.minecraft.stripped_dark_oak_wood": "Binalatang Robleng-dilim na Kahoy",
  "block.minecraft.stripped_jungle_log": "Binalatang Punonggubat na Troso",
  "block.minecraft.stripped_jungle_wood": "Binalatang Punonggubat na Kahoy",
  "block.minecraft.stripped_mangrove_log": "Binalatang Trosong Bakawan",
  "block.minecraft.stripped_mangrove_wood": "Binalatang Bakawang Kahoy",
  "block.minecraft.stripped_oak_log": "Binalatang Robleng Troso",
  "block.minecraft.stripped_oak_wood": "Binalatang Robleng Kahoy",
  "block.minecraft.stripped_pale_oak_log": "Binalatang Robleng-putlang Troso",
  "block.minecraft.stripped_pale_oak_wood": "Binalatang Robleng-putlang Kahoy",
  "block.minecraft.stripped_spruce_log": "Binalatang Sahing na Troso",
  "block.minecraft.stripped_spruce_wood": "Binalatang Sahing na Kahoy",
  "block.minecraft.stripped_warped_hyphae": "Binalatang Kiwal na Hiblay",
  "block.minecraft.stripped_warped_stem": "Binalatang Kiwal na Tangkay",
  "block.minecraft.structure_block": "Bloke ng Kayarian",
  "block.minecraft.structure_void": "Patlang ng Kayarian",
  "block.minecraft.sugar_cane": "Tubo",
  "block.minecraft.sunflower": "Mirasol",
  "block.minecraft.suspicious_gravel": "Kahina-hinalang Bisil",
  "block.minecraft.suspicious_sand": "Kahina-hinalang Buhangin",
  "block.minecraft.sweet_berry_bush": "Palumpong ng Tamising Pagla",
  "block.minecraft.tall_dry_grass": "Mataas na Tuyong Damo",
  "block.minecraft.tall_grass": "Mataas na Damo",
  "block.minecraft.tall_seagrass": "Mataas na Damong-dagat",
  "block.minecraft.target": "Tudlaan",
  "block.minecraft.terracotta": "Lutunlupa",
  "block.minecraft.test_block": "Bloke ng Pangsuri",
  "block.minecraft.test_instance_block": "Bloke ng Pangyayaring Pagsusuri",
  "block.minecraft.tinted_glass": "Kinulayang Salamin",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Nakapatay ang pagsabog ng TNT",
  "block.minecraft.torch": "Sulo",
  "block.minecraft.torchflower": "Sulumbulak",
  "block.minecraft.torchflower_crop": "Pananim na Sulumbulak",
  "block.minecraft.trapped_chest": "Umang na Kaban",
  "block.minecraft.trial_spawner": "Pagsubok na Likhaan",
  "block.minecraft.tripwire": "Dapaan",
  "block.minecraft.tripwire_hook": "Sabitan ng Dapaan",
  "block.minecraft.tube_coral": "Bumbong-sagay",
  "block.minecraft.tube_coral_block": "Bloke ng Bumbong-sagay",
  "block.minecraft.tube_coral_fan": "Bumbong-paypaysagay",
  "block.minecraft.tube_coral_wall_fan": "Bumbong-paypaysagay sa Pader",
  "block.minecraft.tuff": "Tupo",
  "block.minecraft.tuff_brick_slab": "Laryong Tupong Dalig",
  "block.minecraft.tuff_brick_stairs": "Laryong Tupong Hagdanan",
  "block.minecraft.tuff_brick_wall": "Laryong Tupong Pader",
  "block.minecraft.tuff_bricks": "Laryong Tupo",
  "block.minecraft.tuff_slab": "Tupong Dalig",
  "block.minecraft.tuff_stairs": "Tupong Hagdanan",
  "block.minecraft.tuff_wall": "Tupong Pader",
  "block.minecraft.turtle_egg": "Itlog ng Pawikan",
  "block.minecraft.twisting_vines": "Pulupot na Baging",
  "block.minecraft.twisting_vines_plant": "Pulupot na Halamang Baging",
  "block.minecraft.vault": "Kahang Bakal",
  "block.minecraft.verdant_froglight": "Lungtiang Palakanag",
  "block.minecraft.vine": "Baging",
  "block.minecraft.void_air": "Hangin ng Kawalan",
  "block.minecraft.wall_torch": "Sulo sa Pader",
  "block.minecraft.warped_button": "Kiwal na Pindutan",
  "block.minecraft.warped_door": "Kiwal na Pinto",
  "block.minecraft.warped_fence": "Kiwal na Bakod",
  "block.minecraft.warped_fence_gate": "Kiwal na Tarangkahan",
  "block.minecraft.warped_fungus": "Kiwal na Kabuti",
  "block.minecraft.warped_hanging_sign": "Kiwal na Karatulang Nakasabit",
  "block.minecraft.warped_hyphae": "Kiwal na Hiblay",
  "block.minecraft.warped_nylium": "Kiwal na Niblayan",
  "block.minecraft.warped_planks": "Kiwal na Tabla",
  "block.minecraft.warped_pressure_plate": "Kiwal na Apakan",
  "block.minecraft.warped_roots": "Kiwal na Ugat",
  "block.minecraft.warped_shelf": "Kiwal na Salansanan",
  "block.minecraft.warped_sign": "Kiwal na Karatula",
  "block.minecraft.warped_slab": "Kiwal na Dalig",
  "block.minecraft.warped_stairs": "Kiwal na Hagdanan",
  "block.minecraft.warped_stem": "Kiwal na Tangkay",
  "block.minecraft.warped_trapdoor": "Kiwal na Bukasan",
  "block.minecraft.warped_wall_hanging_sign": "Kiwal na Karatulang Nakasabit sa Pader",
  "block.minecraft.warped_wall_sign": "Kiwal na Karatula sa Pader",
  "block.minecraft.warped_wart_block": "Bloke ng Kiwal na Butig",
  "block.minecraft.water": "Tubig",
  "block.minecraft.water_cauldron": "Kaldero ng Tubig",
  "block.minecraft.waxed_chiseled_copper": "Pinagkitang Pinaitang Tanso",
  "block.minecraft.waxed_copper_bars": "Pinagkitang Tansong Rehas",
  "block.minecraft.waxed_copper_block": "Pinagkitang Bloke ng Tanso",
  "block.minecraft.waxed_copper_bulb": "Pinagkitang Tansong Bumbilya",
  "block.minecraft.waxed_copper_chain": "Pinagkitang Tansong Tanikala",
  "block.minecraft.waxed_copper_chest": "Pinagkitang Tansong Kaban",
  "block.minecraft.waxed_copper_door": "Pinagkitang Tansong Pinto",
  "block.minecraft.waxed_copper_golem_statue": "Pinagkitang Estatwang Tansong Golem",
  "block.minecraft.waxed_copper_grate": "Pinagkitang Tansong Barandilyas",
  "block.minecraft.waxed_copper_lantern": "Pinagkitang Tansong Paritaan",
  "block.minecraft.waxed_copper_trapdoor": "Pinagkitang Tansong Bukasan",
  "block.minecraft.waxed_cut_copper": "Pinagkitang Tinabas na Tanso",
  "block.minecraft.waxed_cut_copper_slab": "Pinagkitang Tinabas na Tansong Dalig",
  "block.minecraft.waxed_cut_copper_stairs": "Pinagkitang Tinabas na Tansong Hagdanan",
  "block.minecraft.waxed_exposed_chiseled_copper": "Pinagkitang Hayag na Pinaitang Tanso",
  "block.minecraft.waxed_exposed_copper": "Pinagkitang Hayag na Tanso",
  "block.minecraft.waxed_exposed_copper_bars": "Pinagkitang Hayag na Tansong Rehas",
  "block.minecraft.waxed_exposed_copper_bulb": "Pinagkitang Hayag na Tansong Bumbilya",
  "block.minecraft.waxed_exposed_copper_chain": "Pinagkitang Hayag ng Tansong Tanikala",
  "block.minecraft.waxed_exposed_copper_chest": "Pinagkitang Hayag na Tansong Kaban",
  "block.minecraft.waxed_exposed_copper_door": "Pinagkitang Hayag na Tansong Pinto",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Pinagkitang Hayag na Estatwang Tansong Golem",
  "block.minecraft.waxed_exposed_copper_grate": "Pinagkitang Hayag na Tansong Barandilyas",
  "block.minecraft.waxed_exposed_copper_lantern": "Pinagkitang Hayag na Tansong Paritaan",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Pinagkitang Hayag na Tansong Bukasan",
  "block.minecraft.waxed_exposed_cut_copper": "Pinagkitang Hayag na Tinabas na Tanso",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Pinagkitang Hayag na Tinabas na Tansong Dalig",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Pinagkitang Hayag na Tinabas na Tansong Hagdanan",
  "block.minecraft.waxed_exposed_lightning_rod": "Pinagkitang Hayag na Kayag-Kidlat",
  "block.minecraft.waxed_lightning_rod": "Pinagkitang Kayag-Kidlat",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Pinagkitang Nasadagisik na Pinaitang Tanso",
  "block.minecraft.waxed_oxidized_copper": "Pinagkitang Nasadagisik na Tanso",
  "block.minecraft.waxed_oxidized_copper_bars": "Pinagkitang Nasadagisik na Tansong Rehas",
  "block.minecraft.waxed_oxidized_copper_bulb": "Pinagkitang Nasadagisik na Tansong Bumbilya",
  "block.minecraft.waxed_oxidized_copper_chain": "Pinagkitang Nasadagisik na Tansong Tanikala",
  "block.minecraft.waxed_oxidized_copper_chest": "Pinagkitang Nasadagisik na Tansong Kaban",
  "block.minecraft.waxed_oxidized_copper_door": "Pinagkitang Nasadagisik na Tansong Pinto",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Pinagkitang Nasadagisik na Estatwang Tansong Golem",
  "block.minecraft.waxed_oxidized_copper_grate": "Pinagkitang Nasadagisik na Tansong Barandilyas",
  "block.minecraft.waxed_oxidized_copper_lantern": "Pinagkitang Nasadagisik na Tansong Paritaan",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Pinagkitang Nasadagisik na Tansong Bukasan",
  "block.minecraft.waxed_oxidized_cut_copper": "Pinagkitang Nasadagisik na Tinabas na Tanso",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Pinagkitang Nasadagisik na Tinabas na Tansong Dalig",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Pinagkitang Nasadagisik na Tinabas na Tansong Hagdanan",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pinagkitang Nasadagisik na Kayag-Kidlat",
  "block.minecraft.waxed_weathered_chiseled_copper": "Pinagkitang Nasapanhong Pinaitang Tanso",
  "block.minecraft.waxed_weathered_copper": "Pinagkitang Nasapanhong Tanso",
  "block.minecraft.waxed_weathered_copper_bars": "Pinagkitang Nasapanhong Tansong Rehas",
  "block.minecraft.waxed_weathered_copper_bulb": "Pinagkitang Nasapanhong Tansong Bumbilya",
  "block.minecraft.waxed_weathered_copper_chain": "Pinagkitang Nasapanhong Tansong Tanikala",
  "block.minecraft.waxed_weathered_copper_chest": "Pinagkitang Nasapanhong Tansong Kaban",
  "block.minecraft.waxed_weathered_copper_door": "Pinagkitang Nasapanhong Tansong Pinto",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Pinagkitang Nasapanhong Estatwang Tansong Golem",
  "block.minecraft.waxed_weathered_copper_grate": "Pinagkitang Nasapanhong Tansong Barandilyas",
  "block.minecraft.waxed_weathered_copper_lantern": "Pinagkitang Nasapanhong Tansong Paritaan",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Pinagkitang Nasapanhong Tansong Bukasan",
  "block.minecraft.waxed_weathered_cut_copper": "Pinagkitang Nasapanhong Tinabas na Tanso",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Pinagkitang Nasapanhong Tinabas na Tansong Dalig",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Pinagkitang Nasapanhong Tinabas na Tansong Hagdanan",
  "block.minecraft.waxed_weathered_lightning_rod": "Pinagkitang Nasapanhong Kayag-Kidlat",
  "block.minecraft.weathered_chiseled_copper": "Nasapanhong Pinaitang Tanso",
  "block.minecraft.weathered_copper": "Kinalawang na Tanso",
  "block.minecraft.weathered_copper_bars": "Nasapanhong Tansong Rehas",
  "block.minecraft.weathered_copper_bulb": "Nasapanhong Tansong Bumbilya",
  "block.minecraft.weathered_copper_chain": "Nasapanhong Tansong Tanikala",
  "block.minecraft.weathered_copper_chest": "Nasapanhong Tansong Kaban",
  "block.minecraft.weathered_copper_door": "Nasapanhong Tansong Pinto",
  "block.minecraft.weathered_copper_golem_statue": "Nasapanhong Estatwang Tansong Golem",
  "block.minecraft.weathered_copper_grate": "Nasapanhong Tansong Barandilyas",
  "block.minecraft.weathered_copper_lantern": "Nasapanhong Tansong Paritaan",
  "block.minecraft.weathered_copper_trapdoor": "Nasapanhong Tansong Bukasan",
  "block.minecraft.weathered_cut_copper": "Nasapanhong Tinabas na Tanso",
  "block.minecraft.weathered_cut_copper_slab": "Nasapanhong Tinabas na Tansong Dalig",
  "block.minecraft.weathered_cut_copper_stairs": "Nasapanhong Tinabas na Tansong Hagdanan",
  "block.minecraft.weathered_lightning_rod": "Nasapanhong Kayag-Kidlat",
  "block.minecraft.weeping_vines": "Lumuluhang Baging",
  "block.minecraft.weeping_vines_plant": "Lumuluhang Halamang Baging",
  "block.minecraft.wet_sponge": "Basang Espongha",
  "block.minecraft.wheat": "Pananim na Trigo",
  "block.minecraft.white_banner": "Puting Watawat",
  "block.minecraft.white_bed": "Puting Higaan",
  "block.minecraft.white_candle": "Puting Sasang",
  "block.minecraft.white_candle_cake": "Keyk na may Puting Sasang",
  "block.minecraft.white_carpet": "Puting Banig",
  "block.minecraft.white_concrete": "Puting Gawambato",
  "block.minecraft.white_concrete_powder": "Puting Gawambatong Buhangin",
  "block.minecraft.white_glazed_terracotta": "Puting Sinalaminang Lutunlupa",
  "block.minecraft.white_shulker_box": "Puting Kahon ng Shulker",
  "block.minecraft.white_stained_glass": "Puting Salamin",
  "block.minecraft.white_stained_glass_pane": "Puting Durungawan",
  "block.minecraft.white_terracotta": "Puting Lutunlupa",
  "block.minecraft.white_tulip": "Tulipang Puti",
  "block.minecraft.white_wool": "Puting Lana",
  "block.minecraft.wildflowers": "Ilahas na Bulaklak",
  "block.minecraft.wither_rose": "Rosas ng Wither",
  "block.minecraft.wither_skeleton_skull": "Bungo ng Wither na Kalansay",
  "block.minecraft.wither_skeleton_wall_skull": "Bungo ng Wither na Kalansay sa Pader",
  "block.minecraft.yellow_banner": "Dilaw na Watawat",
  "block.minecraft.yellow_bed": "Dilaw na Higaan",
  "block.minecraft.yellow_candle": "Dilaw na Sasang",
  "block.minecraft.yellow_candle_cake": "Keyk na may Dilaw na Sasang",
  "block.minecraft.yellow_carpet": "Dilaw na Banig",
  "block.minecraft.yellow_concrete": "Dilaw na Gawambato",
  "block.minecraft.yellow_concrete_powder": "Dilaw na Gawambatong Buhangin",
  "block.minecraft.yellow_glazed_terracotta": "Dilaw na Sinalaminang Lutunlupa",
  "block.minecraft.yellow_shulker_box": "Dilaw na Kahon ng Shulker",
  "block.minecraft.yellow_stained_glass": "Dilaw na Salamin",
  "block.minecraft.yellow_stained_glass_pane": "Dilaw na Durungawan",
  "block.minecraft.yellow_terracotta": "Dilaw na Lutunlupa",
  "block.minecraft.yellow_wool": "Dilaw na Lana",
  "block.minecraft.zombie_head": "Ulo ng Maranhig",
  "block.minecraft.zombie_wall_head": "Ulo ng Maranhig sa Pader",
  "item.minecraft.acacia_boat": "Langil na Bangka",
  "item.minecraft.acacia_chest_boat": "Langil na Bangkang may Kaban",
  "item.minecraft.allay_spawn_egg": "Panlikhaang Itlog ng Alalay",
  "item.minecraft.amethyst_shard": "Bubog ng Amatista",
  "item.minecraft.angler_pottery_shard": "Mangingisdang Bubog ng Palayok",
  "item.minecraft.angler_pottery_sherd": "Mangingisdang Bibinga ng Palayok",
  "item.minecraft.apple": "Mansanas",
  "item.minecraft.archer_pottery_shard": "Mamamanang Bubog ng Palayok",
  "item.minecraft.archer_pottery_sherd": "Mamamanang Bibinga ng Palayok",
  "item.minecraft.armadillo_scute": "Kaliskis ng Armadilyo",
  "item.minecraft.armadillo_spawn_egg": "Panlikhaang Itlog ng Armadilyo",
  "item.minecraft.armor_stand": "Sabitan ng Sapyaw",
  "item.minecraft.arms_up_pottery_shard": "Taas-kamay na Bubog ng Palayok",
  "item.minecraft.arms_up_pottery_sherd": "Taas-kamay na Bibinga ng Palayok",
  "item.minecraft.arrow": "Palaso",
  "item.minecraft.axolotl_bucket": "Timba ng Aholote",
  "item.minecraft.axolotl_spawn_egg": "Panlikhaang Itlog ng Aholote",
  "item.minecraft.baked_potato": "Lutong Abukot",
  "item.minecraft.bamboo_chest_raft": "Kawayang Balsang may Kaban",
  "item.minecraft.bamboo_raft": "Kawayang Balsa",
  "item.minecraft.bat_spawn_egg": "Panlikhaang Itlog ng Paniki",
  "item.minecraft.bee_spawn_egg": "Panlikhaang Itlog ng Bubuyog",
  "item.minecraft.beef": "Hilaw na Karneng Baka",
  "item.minecraft.beetroot": "Remolatsa",
  "item.minecraft.beetroot_seeds": "Buto ng Remolatsa",
  "item.minecraft.beetroot_soup": "Sabaw ng Remolatsa",
  "item.minecraft.birch_boat": "Abedul na Bangka",
  "item.minecraft.birch_chest_boat": "Abedul na Bangkang may Kaban",
  "item.minecraft.black_bundle": "Itim na Bungkos",
  "item.minecraft.black_dye": "Itim na Pangulay",
  "item.minecraft.black_harness": "Itim na Guwarnisyon",
  "item.minecraft.blade_pottery_shard": "Talim na Bubog ng Palayok",
  "item.minecraft.blade_pottery_sherd": "Talim na Bibinga ng Palayok",
  "item.minecraft.blaze_powder": "Liyabo",
  "item.minecraft.blaze_rod": "Liyabaras",
  "item.minecraft.blaze_spawn_egg": "Panlikhaang Itlog ng Lagablab",
  "item.minecraft.blue_bundle": "Bughaw na Bungkos",
  "item.minecraft.blue_dye": "Bughaw na Pangulay",
  "item.minecraft.blue_egg": "Bughaw na Itlog",
  "item.minecraft.blue_harness": "Bughaw na Guwarnisyon",
  "item.minecraft.bogged_spawn_egg": "Panlikhaang Itlog ng Nabalahaw",
  "item.minecraft.bolt_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Rematseng Gayak sa Baluti",
  "item.minecraft.bone": "Buto",
  "item.minecraft.bone_meal": "Kainang Buto",
  "item.minecraft.book": "Aklat",
  "item.minecraft.bordure_indented_banner_pattern": "Hulwaran ng Watawat ng Yuping Libot",
  "item.minecraft.bow": "Pana",
  "item.minecraft.bowl": "Mangkok",
  "item.minecraft.bread": "Tinapay",
  "item.minecraft.breeze_rod": "Simoybaras",
  "item.minecraft.breeze_spawn_egg": "Panlikhaang Itlog ng Hagayhay",
  "item.minecraft.brewer_pottery_shard": "Mananambal na Bubog ng Palayok",
  "item.minecraft.brewer_pottery_sherd": "Mananambal na Bibinga ng Palayok",
  "item.minecraft.brewing_stand": "Kuluan",
  "item.minecraft.brick": "Tipak ng Laryo",
  "item.minecraft.brown_bundle": "Kayumangging Bungkos",
  "item.minecraft.brown_dye": "Kayumangging Pangulay",
  "item.minecraft.brown_egg": "Kayumangging Itlog",
  "item.minecraft.brown_harness": "Kayumangging Guwarnisyon",
  "item.minecraft.brush": "Pamaspas",
  "item.minecraft.bucket": "Timba",
  "item.minecraft.bundle": "Bungkos",
  "item.minecraft.bundle.empty": "Walang laman",
  "item.minecraft.bundle.empty.description": "Makahahawak ng halong salansan ng mga bagay",
  "item.minecraft.bundle.full": "Puno na",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Liyab na Bubog ng Palayok",
  "item.minecraft.burn_pottery_sherd": "Liyab na Bibinga ng Palayok",
  "item.minecraft.camel_husk_spawn_egg": "Panlikhaang Itlog ng Nangaipang Kamelyo",
  "item.minecraft.camel_spawn_egg": "Panlikhaang Itlog ng Kamelyo",
  "item.minecraft.carrot": "Asanorya",
  "item.minecraft.carrot_on_a_stick": "Asanorya sa Tungkod",
  "item.minecraft.cat_spawn_egg": "Panlikhaang Itlog ng Pusa",
  "item.minecraft.cauldron": "Kaldero",
  "item.minecraft.cave_spider_spawn_egg": "Panlikhaang Itlog ng Gagambang-yungib",
  "item.minecraft.chainmail_boots": "Tanikalang Paruka",
  "item.minecraft.chainmail_chestplate": "Tanikalang Baluti",
  "item.minecraft.chainmail_helmet": "Tanikalang Kupyang",
  "item.minecraft.chainmail_leggings": "Tanikalang Polaynas",
  "item.minecraft.charcoal": "Uling",
  "item.minecraft.cherry_boat": "Sakurang Bangka",
  "item.minecraft.cherry_chest_boat": "Sakurang Bangkang may Kaban",
  "item.minecraft.chest_minecart": "Karitelang may Kaban",
  "item.minecraft.chicken": "Hilaw na Manok",
  "item.minecraft.chicken_spawn_egg": "Panlikhaang Itlog ng Manok",
  "item.minecraft.chorus_fruit": "Bungang-koro",
  "item.minecraft.clay_ball": "Bolang-luwad",
  "item.minecraft.clock": "Taknaan",
  "item.minecraft.coal": "Batong-Uling",
  "item.minecraft.coast_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Malabaybaying Gayak sa Baluti",
  "item.minecraft.cocoa_beans": "Kakaw",
  "item.minecraft.cod": "Hilaw na Bakalaw",
  "item.minecraft.cod_bucket": "Timba ng Bakalaw",
  "item.minecraft.cod_spawn_egg": "Panlikhaang Itlog ng Bakalaw",
  "item.minecraft.command_block_minecart": "Karitelang may Bloke ng Utos",
  "item.minecraft.compass": "Paraluman",
  "item.minecraft.cooked_beef": "Lutong Karneng Baka",
  "item.minecraft.cooked_chicken": "Lutong Manok",
  "item.minecraft.cooked_cod": "Luto na Bakalaw",
  "item.minecraft.cooked_mutton": "Lutong Karne ng Tupa",
  "item.minecraft.cooked_porkchop": "Lutong Porkchop",
  "item.minecraft.cooked_rabbit": "Lutong Karne ng Kuneho",
  "item.minecraft.cooked_salmon": "Lutong Salmon",
  "item.minecraft.cookie": "Galyetas",
  "item.minecraft.copper_axe": "Tansong Palakol",
  "item.minecraft.copper_boots": "Tansong Paruka",
  "item.minecraft.copper_chestplate": "Tansong Baluti",
  "item.minecraft.copper_golem_spawn_egg": "Panilkhaang Itlog ng Tansong Golem",
  "item.minecraft.copper_helmet": "Tansong Kupyang",
  "item.minecraft.copper_hoe": "Tansong Asarol",
  "item.minecraft.copper_horse_armor": "Tansong Pangkabayong Sapyaw",
  "item.minecraft.copper_ingot": "Linggote ng Tanso",
  "item.minecraft.copper_leggings": "Tansong Polaynas",
  "item.minecraft.copper_nautilus_armor": "Tansong Panlagang Sapyaw",
  "item.minecraft.copper_nugget": "Pirasong Tanso",
  "item.minecraft.copper_pickaxe": "Tansong Patik",
  "item.minecraft.copper_shovel": "Tansong Pala",
  "item.minecraft.copper_spear": "Tansong Sibat",
  "item.minecraft.copper_sword": "Tansong Tabak",
  "item.minecraft.cow_spawn_egg": "Panlikhaang Itlog ng Baka",
  "item.minecraft.creaking_spawn_egg": "Panlikhaang Itlog ng Lumalangitngit",
  "item.minecraft.creeper_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.creeper_banner_pattern.desc": "Tatak ng Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Hulwaran ng Watawat ng Tatak ng Creeper",
  "item.minecraft.creeper_spawn_egg": "Panlikhaang Itlog ng Kilabot",
  "item.minecraft.crossbow": "Balais",
  "item.minecraft.crossbow.projectile": "Panudla:",
  "item.minecraft.crossbow.projectile.multiple": "Panudla: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Panudla: %s",
  "item.minecraft.cyan_bundle": "Cyan na Bungkos",
  "item.minecraft.cyan_dye": "Cyan na Pangulay",
  "item.minecraft.cyan_harness": "Cyan na Guwarnisyon",
  "item.minecraft.danger_pottery_shard": "Panganib na Bubog ng Palayok",
  "item.minecraft.danger_pottery_sherd": "Panganib na Bibinga ng Palayok",
  "item.minecraft.dark_oak_boat": "Robleng-dilim na Bangka",
  "item.minecraft.dark_oak_chest_boat": "Robleng-dilim na Bangkang may Kaban",
  "item.minecraft.debug_stick": "Tungkod sa Pagdalisay",
  "item.minecraft.debug_stick.empty": "Walang mga property ang %s",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) ang napili",
  "item.minecraft.debug_stick.update": "\"%s\" naging %s",
  "item.minecraft.diamond": "Diyamante",
  "item.minecraft.diamond_axe": "Diyamanteng Palakol",
  "item.minecraft.diamond_boots": "Diyamanteng Paruka",
  "item.minecraft.diamond_chestplate": "Diyamanteng Baluti",
  "item.minecraft.diamond_helmet": "Diyamanteng Kupyang",
  "item.minecraft.diamond_hoe": "Diyamanteng Asarol",
  "item.minecraft.diamond_horse_armor": "Diyamanteng Pangkabayong Sapyaw",
  "item.minecraft.diamond_leggings": "Diyamanteng Polaynas",
  "item.minecraft.diamond_nautilus_armor": "Diyamanteng Panlagang Sapyaw",
  "item.minecraft.diamond_pickaxe": "Diyamanteng Patik",
  "item.minecraft.diamond_shovel": "Diyamanteng Pala",
  "item.minecraft.diamond_spear": "Diyamanteng Sibat",
  "item.minecraft.diamond_sword": "Diyamanteng Tabak",
  "item.minecraft.disc_fragment_5": "Biyak ng Plaka",
  "item.minecraft.disc_fragment_5.desc": "Plaka - 5",
  "item.minecraft.dolphin_spawn_egg": "Panlikhaang Itlog ng Dolpin",
  "item.minecraft.donkey_spawn_egg": "Panlikhaang Itlog ng Asno",
  "item.minecraft.dragon_breath": "Hininga ng Bakunawan",
  "item.minecraft.dried_kelp": "Tuyong Kelp",
  "item.minecraft.drowned_spawn_egg": "Panlikhaang Itlog ng Siyokoy",
  "item.minecraft.dune_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Malabuhanginang Gayak sa Baluti",
  "item.minecraft.echo_shard": "Bubog ng Alingawgaw",
  "item.minecraft.egg": "Itlog",
  "item.minecraft.elder_guardian_spawn_egg": "Panlikhaang Itlog ng Matandang Tagabantay",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Aklat ng Salamangka",
  "item.minecraft.enchanted_golden_apple": "Marahuyong Gintong Mansanas",
  "item.minecraft.end_crystal": "End na Kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Panlikhaang Itlog ng Bakunawang Ender",
  "item.minecraft.ender_eye": "Mata ng Ender",
  "item.minecraft.ender_pearl": "Perlas na Ender",
  "item.minecraft.enderman_spawn_egg": "Panlikhaang Itlog ng Enderman",
  "item.minecraft.endermite_spawn_egg": "Panlikhaang Itlog ng Endermite",
  "item.minecraft.evoker_spawn_egg": "Panlikhaang Itlog ng Tagapukaw",
  "item.minecraft.experience_bottle": "Bote ng Karanasan",
  "item.minecraft.explorer_pottery_shard": "Manlalakbay na Bubog ng Palayok",
  "item.minecraft.explorer_pottery_sherd": "Manlalakbay na Bibinga ng Palayok",
  "item.minecraft.eye_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Malamatang Gayak sa Baluti",
  "item.minecraft.feather": "Balahibo",
  "item.minecraft.fermented_spider_eye": "Tinimplang Mata ng Gagamba",
  "item.minecraft.field_masoned_banner_pattern": "Hulwaran ng Watawat ng Laryong Larang",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Karga ng Apoy",
  "item.minecraft.firework_rocket": "Kuwitis",
  "item.minecraft.firework_rocket.flight": "Tagal ng Lipad:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bituin ng Kuwitis",
  "item.minecraft.firework_star.black": "Itim",
  "item.minecraft.firework_star.blue": "Bughaw",
  "item.minecraft.firework_star.brown": "Kayumanggi",
  "item.minecraft.firework_star.custom_color": "Pasadya",
  "item.minecraft.firework_star.cyan": "Cyan",
  "item.minecraft.firework_star.fade_to": "Papunta sa",
  "item.minecraft.firework_star.flicker": "Kislap",
  "item.minecraft.firework_star.gray": "Abo",
  "item.minecraft.firework_star.green": "Lungtian",
  "item.minecraft.firework_star.light_blue": "Langit",
  "item.minecraft.firework_star.light_gray": "Pilak",
  "item.minecraft.firework_star.lime": "Dayap",
  "item.minecraft.firework_star.magenta": "Mahenta",
  "item.minecraft.firework_star.orange": "Bulantubig",
  "item.minecraft.firework_star.pink": "Kalimbahin",
  "item.minecraft.firework_star.purple": "Haban",
  "item.minecraft.firework_star.red": "Pula",
  "item.minecraft.firework_star.shape": "Di-alam na Hugis",
  "item.minecraft.firework_star.shape.burst": "Kalat",
  "item.minecraft.firework_star.shape.creeper": "Hugis-Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Malaking Bola",
  "item.minecraft.firework_star.shape.small_ball": "Maliit na Bola",
  "item.minecraft.firework_star.shape.star": "Hugis-bituin",
  "item.minecraft.firework_star.trail": "Landas",
  "item.minecraft.firework_star.white": "Puti",
  "item.minecraft.firework_star.yellow": "Dilaw",
  "item.minecraft.fishing_rod": "Pamingwit",
  "item.minecraft.flint": "Puyusan",
  "item.minecraft.flint_and_steel": "Panindi",
  "item.minecraft.flow_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Daloy na Gayak sa Baluti",
  "item.minecraft.flow_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.flow_banner_pattern.desc": "Daloy",
  "item.minecraft.flow_banner_pattern.new": "Hulwaran ng Watawat na Daloy",
  "item.minecraft.flow_pottery_sherd": "Daloy na Bibinga ng Palayok",
  "item.minecraft.flower_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.flower_banner_pattern.desc": "Bulakak na Charge",
  "item.minecraft.flower_banner_pattern.new": "Hulwaran ng Watawat ng Tatak ng Bulaklak",
  "item.minecraft.flower_pot": "Plorera",
  "item.minecraft.fox_spawn_egg": "Panlikhaang Itlog ng Soro",
  "item.minecraft.friend_pottery_shard": "Kaibigang Bubog na Palayok",
  "item.minecraft.friend_pottery_sherd": "Kaibigang Bibinga ng Palayok",
  "item.minecraft.frog_spawn_egg": "Panlikhaang Itlog ng Palaka",
  "item.minecraft.furnace_minecart": "Karitelang may Dapugan",
  "item.minecraft.ghast_spawn_egg": "Panlikhaang Itlog ng Ghast",
  "item.minecraft.ghast_tear": "Luha ng Ghast",
  "item.minecraft.glass_bottle": "Salaming Bote",
  "item.minecraft.glistering_melon_slice": "Kumikislap na Hiwa ng Pakwan",
  "item.minecraft.globe_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.globe_banner_pattern.desc": "Hilihid",
  "item.minecraft.globe_banner_pattern.new": "Hulwaran ng Watawat ng Hilihid",
  "item.minecraft.glow_berries": "Kinanging Pagla",
  "item.minecraft.glow_ink_sac": "Supot ng Kinanging Ata",
  "item.minecraft.glow_item_frame": "Kinanging Baskag ng Bagay",
  "item.minecraft.glow_squid_spawn_egg": "Panlikhaang Itlog ng Kinanging Pusit",
  "item.minecraft.glowstone_dust": "Abo ng Batunsinag",
  "item.minecraft.goat_horn": "Sungay ng Kambing",
  "item.minecraft.goat_spawn_egg": "Panlikhaang Itlog ng Kambing",
  "item.minecraft.gold_ingot": "Linggote ng Ginto",
  "item.minecraft.gold_nugget": "Pirasong Ginto",
  "item.minecraft.golden_apple": "Gintong Mansanas",
  "item.minecraft.golden_axe": "Gintong Palakol",
  "item.minecraft.golden_boots": "Gintong Paruka",
  "item.minecraft.golden_carrot": "Gintong Asanorya",
  "item.minecraft.golden_chestplate": "Gintong Baluti",
  "item.minecraft.golden_helmet": "Gintong Kupyang",
  "item.minecraft.golden_hoe": "Gintong Asarol",
  "item.minecraft.golden_horse_armor": "Gintong Pangkabayong Sapyaw",
  "item.minecraft.golden_leggings": "Gintong Polaynas",
  "item.minecraft.golden_nautilus_armor": "Gintong Panlagang Sapyaw",
  "item.minecraft.golden_pickaxe": "Gintong Patik",
  "item.minecraft.golden_shovel": "Gintong Pala",
  "item.minecraft.golden_spear": "Gintong Sibat",
  "item.minecraft.golden_sword": "Gintong Tabak",
  "item.minecraft.gray_bundle": "Abong Bungkos",
  "item.minecraft.gray_dye": "Abong Pangulay",
  "item.minecraft.gray_harness": "Abong Guwarnisyon",
  "item.minecraft.green_bundle": "Lungtiang Bungkos",
  "item.minecraft.green_dye": "Lungtiang Pangulay",
  "item.minecraft.green_harness": "Lungtiang Guwarnisyon",
  "item.minecraft.guardian_spawn_egg": "Panlikhaang Itlog ng Tagabantay",
  "item.minecraft.gunpowder": "Ubat",
  "item.minecraft.guster_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.guster_banner_pattern.desc": "Bugso",
  "item.minecraft.guster_banner_pattern.new": "Hulwaran ng Watawat ng Bugso",
  "item.minecraft.guster_pottery_sherd": "Buhawing Bibinga ng Palayok",
  "item.minecraft.happy_ghast_spawn_egg": "Panlikhaang Itlog ng Masayang Ghast",
  "item.minecraft.harness": "Guwarnisyon",
  "item.minecraft.heart_of_the_sea": "Puso ng Dagat",
  "item.minecraft.heart_pottery_shard": "Pusong Bubog ng Palayok",
  "item.minecraft.heart_pottery_sherd": "Pusong Bibinga ng Palayok",
  "item.minecraft.heartbreak_pottery_shard": "Sirang-pusong Bubog ng Palayok",
  "item.minecraft.heartbreak_pottery_sherd": "Sirang-pusong Bibinga ng Palayok",
  "item.minecraft.hoglin_spawn_egg": "Panlikhaang Itlog ng Hoglin",
  "item.minecraft.honey_bottle": "Bote ng Pulot",
  "item.minecraft.honeycomb": "Saray",
  "item.minecraft.hopper_minecart": "Karitelang may Lukton",
  "item.minecraft.horse_spawn_egg": "Panlikhaang Itlog ng Kabayo",
  "item.minecraft.host_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.host_armor_trim_smithing_template.new": "Malasasandigang Gayak sa Baluti",
  "item.minecraft.howl_pottery_shard": "Lobong Bubog ng Palayok",
  "item.minecraft.howl_pottery_sherd": "Lobong Bibinga ng Palayok",
  "item.minecraft.husk_spawn_egg": "Panlikhaang Itlog ng Nangaipa",
  "item.minecraft.ink_sac": "Supot ng Tinta",
  "item.minecraft.iron_axe": "Bakal na Palakol",
  "item.minecraft.iron_boots": "Bakal na Paruka",
  "item.minecraft.iron_chestplate": "Bakal na Baluti",
  "item.minecraft.iron_golem_spawn_egg": "Panlikhaang Itlog ng Bakal na Golem",
  "item.minecraft.iron_helmet": "Bakal na Kupyang",
  "item.minecraft.iron_hoe": "Bakal na Asarol",
  "item.minecraft.iron_horse_armor": "Bakal na Pangkabayong Sapyaw",
  "item.minecraft.iron_ingot": "Linggote ng Bakal",
  "item.minecraft.iron_leggings": "Bakal na Polaynas",
  "item.minecraft.iron_nautilus_armor": "Bakal na Panlagang Sapyaw",
  "item.minecraft.iron_nugget": "Pirasong Bakal",
  "item.minecraft.iron_pickaxe": "Bakal na Patik",
  "item.minecraft.iron_shovel": "Bakal na Pala",
  "item.minecraft.iron_spear": "Bakal na Sibat",
  "item.minecraft.iron_sword": "Bakal na Tabak",
  "item.minecraft.item_frame": "Baskag ng Bagay",
  "item.minecraft.jungle_boat": "Punonggubat na Bangka",
  "item.minecraft.jungle_chest_boat": "Punonggubat na Bangkang may Kaban",
  "item.minecraft.knowledge_book": "Kaalamang Aklat",
  "item.minecraft.lapis_lazuli": "Lapislasuli",
  "item.minecraft.lava_bucket": "Timba ng Kumukulong Putik",
  "item.minecraft.lead": "Panali",
  "item.minecraft.leather": "Katad",
  "item.minecraft.leather_boots": "Katad na Paruka",
  "item.minecraft.leather_chestplate": "Katad na Tunika",
  "item.minecraft.leather_helmet": "Katad na Kalo",
  "item.minecraft.leather_horse_armor": "Katad na Pangkabayong Sapyaw",
  "item.minecraft.leather_leggings": "Katad na Pantalon",
  "item.minecraft.light_blue_bundle": "Langit na Bungkos",
  "item.minecraft.light_blue_dye": "Langit na Pangulay",
  "item.minecraft.light_blue_harness": "Langit na Guwarnisyon",
  "item.minecraft.light_gray_bundle": "Pilak na Bungkos",
  "item.minecraft.light_gray_dye": "Pilak na Pangulay",
  "item.minecraft.light_gray_harness": "Pilak na Guwarnisyon",
  "item.minecraft.lime_bundle": "Dayap na Bungkos",
  "item.minecraft.lime_dye": "Dayap na Pangulay",
  "item.minecraft.lime_harness": "Dayap na Guwarnisyon",
  "item.minecraft.lingering_potion": "Naglalaging Gayuma",
  "item.minecraft.lingering_potion.effect.awkward": "Naglalaging Asiwang Gayuma",
  "item.minecraft.lingering_potion.effect.empty": "Naglalaging Di-nagagawang Gayuma",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Naglalaging Gayuma ng Katatagan sa Apoy",
  "item.minecraft.lingering_potion.effect.harming": "Naglalaging Gayumang Pampanakit",
  "item.minecraft.lingering_potion.effect.healing": "Naglalaging Gayumang Pampagaling",
  "item.minecraft.lingering_potion.effect.infested": "Naglalaging Gayuma ng Pamumugad",
  "item.minecraft.lingering_potion.effect.invisibility": "Naglalaging Gayuma ng Malikmata",
  "item.minecraft.lingering_potion.effect.leaping": "Naglalaging Gayuma ng Pagtalon",
  "item.minecraft.lingering_potion.effect.levitation": "Naglalaging Gayumang Pampalutang",
  "item.minecraft.lingering_potion.effect.luck": "Naglalaging Gayuma ng Mapalad",
  "item.minecraft.lingering_potion.effect.mundane": "Naglalaging Mababaw na Gayuma",
  "item.minecraft.lingering_potion.effect.night_vision": "Naglalaging Gayumang Pampalinaw-mata",
  "item.minecraft.lingering_potion.effect.oozing": "Naglalaging Gayuma ng Pagnanana",
  "item.minecraft.lingering_potion.effect.poison": "Naglalaging Gayumang Pampalason",
  "item.minecraft.lingering_potion.effect.regeneration": "Naglalaging Gayumang Pampanumbalik",
  "item.minecraft.lingering_potion.effect.slow_falling": "Naglalaging Gayuma ng Marahang Paghulog",
  "item.minecraft.lingering_potion.effect.slowness": "Naglalaging Gayumang Pampabagal",
  "item.minecraft.lingering_potion.effect.strength": "Naglalaging Gayumang Pampalakas",
  "item.minecraft.lingering_potion.effect.swiftness": "Naglalaging Gayumang Pampabilis",
  "item.minecraft.lingering_potion.effect.thick": "Naglalaging Malapot na Gayuma",
  "item.minecraft.lingering_potion.effect.turtle_master": "Naglalaging Gayuma ng Dalubhasang Pawikan",
  "item.minecraft.lingering_potion.effect.water": "Naglalaging Bote ng Tubig",
  "item.minecraft.lingering_potion.effect.water_breathing": "Naglalaging Gayuma ng Paghinga sa Tubig",
  "item.minecraft.lingering_potion.effect.weakness": "Naglalaging Gayumang Pampahina",
  "item.minecraft.lingering_potion.effect.weaving": "Naglalaging Gayuma ng Paghabi",
  "item.minecraft.lingering_potion.effect.wind_charged": "Naglalaging Gayuma ng Pagbuhawi",
  "item.minecraft.llama_spawn_egg": "Panlikhaang Itlog ng Liyama",
  "item.minecraft.lodestone_compass": "Batubalaning Paraluman",
  "item.minecraft.mace": "Pambambo",
  "item.minecraft.magenta_bundle": "Mahentang Bungkos",
  "item.minecraft.magenta_dye": "Mahentang Pangulay",
  "item.minecraft.magenta_harness": "Mahentang Guwarnisyon",
  "item.minecraft.magma_cream": "Magmakatas",
  "item.minecraft.magma_cube_spawn_egg": "Panlikhaang Itlog ng Buuking Magma",
  "item.minecraft.mangrove_boat": "Bakawang Bangka",
  "item.minecraft.mangrove_chest_boat": "Bakawang Bangkang may Kaban",
  "item.minecraft.map": "Blankong Mapa",
  "item.minecraft.melon_seeds": "Buto ng Pakwan",
  "item.minecraft.melon_slice": "Hiwa ng Pakwan",
  "item.minecraft.milk_bucket": "Timba ng Gatas",
  "item.minecraft.minecart": "Karitela",
  "item.minecraft.miner_pottery_shard": "Minerong Bubog ng Palayok",
  "item.minecraft.miner_pottery_sherd": "Minerong Bibinga ng Palayok",
  "item.minecraft.mojang_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.mojang_banner_pattern.desc": "Kuwan",
  "item.minecraft.mojang_banner_pattern.new": "Hulwaran ng Watawat ng Kuwan",
  "item.minecraft.mooshroom_spawn_egg": "Panlikhaang Itlog ng Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Manluluksang Bubog ng Palayok",
  "item.minecraft.mourner_pottery_sherd": "Manluluksang Bibinga ng Palayok",
  "item.minecraft.mule_spawn_egg": "Panlikhaang Itlog ng Mula",
  "item.minecraft.mushroom_stew": "Nilagang Kabute",
  "item.minecraft.music_disc_11": "Plaka",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Plaka",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Plaka",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Plaka",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Plaka",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Plaka",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Plaka",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Plaka",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Kahon ng Musika)",
  "item.minecraft.music_disc_far": "Plaka",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Plaka",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Plaka",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Plaka",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Plaka",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Plaka",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Plaka",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Plaka",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Plaka",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Plaka",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Plaka",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Plaka",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Plaka",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Hilaw na Karne ng Tupa",
  "item.minecraft.name_tag": "Pananda ng Pangalan",
  "item.minecraft.nautilus_shell": "Pungo ng Karakol",
  "item.minecraft.nautilus_spawn_egg": "Panlikhaang Itlog ng Lagan",
  "item.minecraft.nether_brick": "Tipak ng Laryong Nether",
  "item.minecraft.nether_star": "Bituing Nether",
  "item.minecraft.nether_wart": "Nether na Butig",
  "item.minecraft.netherite_axe": "Netheritang Palakol",
  "item.minecraft.netherite_boots": "Netheritang Paruka",
  "item.minecraft.netherite_chestplate": "Netheritang Baluti",
  "item.minecraft.netherite_helmet": "Netheritang Kupyang",
  "item.minecraft.netherite_hoe": "Netheritang Asarol",
  "item.minecraft.netherite_horse_armor": "Netheritang Pangkabayong Sapyaw",
  "item.minecraft.netherite_ingot": "Linggote ng Netherita",
  "item.minecraft.netherite_leggings": "Netheritang Polaynas",
  "item.minecraft.netherite_nautilus_armor": "Netheritang Panlagang Sapyaw",
  "item.minecraft.netherite_pickaxe": "Netheritang Patik",
  "item.minecraft.netherite_scrap": "Pira-pirasong Netherita",
  "item.minecraft.netherite_shovel": "Netheritang Pala",
  "item.minecraft.netherite_spear": "Netheritang Sibat",
  "item.minecraft.netherite_sword": "Netheritang Tabak",
  "item.minecraft.netherite_upgrade_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritang Pampalakas",
  "item.minecraft.oak_boat": "Robleng Bangka",
  "item.minecraft.oak_chest_boat": "Robleng Bangkang may Kaban",
  "item.minecraft.ocelot_spawn_egg": "Panlikhaang Itlog ng Oselot",
  "item.minecraft.ominous_bottle": "Nagbabantang Bote",
  "item.minecraft.ominous_trial_key": "Nagbabantang Susi ng Pagsubok",
  "item.minecraft.orange_bundle": "Bulantubig na Bungkos",
  "item.minecraft.orange_dye": "Bulantubig na Pangulay",
  "item.minecraft.orange_harness": "Bulantubig na Guwarnisyon",
  "item.minecraft.painting": "Larawan",
  "item.minecraft.pale_oak_boat": "Robleng-putlang Bangka",
  "item.minecraft.pale_oak_chest_boat": "Robleng-putlang Bangkang may Kaban",
  "item.minecraft.panda_spawn_egg": "Panlikhaang Itlog ng Panda",
  "item.minecraft.paper": "Kalatas",
  "item.minecraft.parched_spawn_egg": "Panlikhaang Itlog ng Nangatuyot",
  "item.minecraft.parrot_spawn_egg": "Panlikhaang Itlog ng Loro",
  "item.minecraft.phantom_membrane": "Lamad ng Guniguni",
  "item.minecraft.phantom_spawn_egg": "Panlikhaang Itlog ng Guniguni",
  "item.minecraft.pig_spawn_egg": "Panlikhaang Itlog ng Baboy",
  "item.minecraft.piglin_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.piglin_banner_pattern.desc": "Nguso",
  "item.minecraft.piglin_banner_pattern.new": "Hulwaran ng Watawat ng Nguso",
  "item.minecraft.piglin_brute_spawn_egg": "Panlikhaang Itlog ng Halimaw na Piglin",
  "item.minecraft.piglin_spawn_egg": "Panlikhaang Itlog ng Piglin",
  "item.minecraft.pillager_spawn_egg": "Panlikhaang Itlog ng Mandarambong",
  "item.minecraft.pink_bundle": "Kalimbahing Bungkos",
  "item.minecraft.pink_dye": "Kalimbahing Pangulay",
  "item.minecraft.pink_harness": "Kalimbahing Guwarnisyon",
  "item.minecraft.pitcher_plant": "Pitsel-pitsel",
  "item.minecraft.pitcher_pod": "Binhi ng Pitsel-pitsel",
  "item.minecraft.plenty_pottery_shard": "Saganang Bubog ng Palayok",
  "item.minecraft.plenty_pottery_sherd": "Saganang Bibinga ng Palayok",
  "item.minecraft.poisonous_potato": "Nakalalasong Abukot",
  "item.minecraft.polar_bear_spawn_egg": "Panlikhaang Itlog ng Osong Puti",
  "item.minecraft.popped_chorus_fruit": "Ihaw na Bungang-koro",
  "item.minecraft.porkchop": "Hilaw na Porkchop",
  "item.minecraft.potato": "Abukot",
  "item.minecraft.potion": "Gayuma",
  "item.minecraft.potion.effect.awkward": "Asiwang Gayuma",
  "item.minecraft.potion.effect.empty": "Di-nagagawang Gayuma",
  "item.minecraft.potion.effect.fire_resistance": "Gayuma ng Katatagan sa Apoy",
  "item.minecraft.potion.effect.harming": "Gayumang Pampanakit",
  "item.minecraft.potion.effect.healing": "Gayumang Pampagaling",
  "item.minecraft.potion.effect.infested": "Gayuma ng Pamumugad",
  "item.minecraft.potion.effect.invisibility": "Gayuma ng Malikmata",
  "item.minecraft.potion.effect.leaping": "Gayuma ng Pagtalon",
  "item.minecraft.potion.effect.levitation": "Gayumang Pampalutang",
  "item.minecraft.potion.effect.luck": "Gayumang Pampanigo",
  "item.minecraft.potion.effect.mundane": "Mababaw na Gayuma",
  "item.minecraft.potion.effect.night_vision": "Gayumang Pampalinaw-mata",
  "item.minecraft.potion.effect.oozing": "Gayuma ng Pagnanana",
  "item.minecraft.potion.effect.poison": "Gayumang Pampalason",
  "item.minecraft.potion.effect.regeneration": "Gayumang Pampanumbalik",
  "item.minecraft.potion.effect.slow_falling": "Gayuma ng Marahang Pagbagsak",
  "item.minecraft.potion.effect.slowness": "Gayumang Pampabagal",
  "item.minecraft.potion.effect.strength": "Gayumang Pampalakas",
  "item.minecraft.potion.effect.swiftness": "Gayumang Pampabilis",
  "item.minecraft.potion.effect.thick": "Malapot na Gayuma",
  "item.minecraft.potion.effect.turtle_master": "Gayuma ng Dalubhasang Pawikan",
  "item.minecraft.potion.effect.water": "Bote ng Tubig",
  "item.minecraft.potion.effect.water_breathing": "Gayuma ng Paghinga sa Tubig",
  "item.minecraft.potion.effect.weakness": "Gayumang Pampahina",
  "item.minecraft.potion.effect.weaving": "Gayuma ng Paghabi",
  "item.minecraft.potion.effect.wind_charged": "Gayuma ng Pagbuhawi",
  "item.minecraft.pottery_shard_archer": "Mamamanang Bubog ng Palayok",
  "item.minecraft.pottery_shard_arms_up": "Taas-kamay na Bubog ng Palayok",
  "item.minecraft.pottery_shard_prize": "Gantimpalang Bubog ng Palayok",
  "item.minecraft.pottery_shard_skull": "Bungong Bubog ng Palayok",
  "item.minecraft.powder_snow_bucket": "Timba ng Niyebeng-pulbos",
  "item.minecraft.prismarine_crystals": "Kristal ng Prismarin",
  "item.minecraft.prismarine_shard": "Bubog ng Prismarin",
  "item.minecraft.prize_pottery_shard": "Gantimpalang Bubog ng Palayok",
  "item.minecraft.prize_pottery_sherd": "Gantimpalang Bibinga ng Palayok",
  "item.minecraft.pufferfish": "Buteteng-laot",
  "item.minecraft.pufferfish_bucket": "Timba ng Buteteng-laot",
  "item.minecraft.pufferfish_spawn_egg": "Panlikhaang Itlog ng Buteteng-laot",
  "item.minecraft.pumpkin_pie": "Kakining Kandos",
  "item.minecraft.pumpkin_seeds": "Buto ng Kandos",
  "item.minecraft.purple_bundle": "Habang Bungkos",
  "item.minecraft.purple_dye": "Habang Pangulay",
  "item.minecraft.purple_harness": "Habang Guwarnisyon",
  "item.minecraft.quartz": "Kinyang-Nether",
  "item.minecraft.rabbit": "Hilaw na Karne ng Kuneho",
  "item.minecraft.rabbit_foot": "Paa ng Kuneho",
  "item.minecraft.rabbit_hide": "Tago ng Kuneho",
  "item.minecraft.rabbit_spawn_egg": "Panlikhaang Itlog ng Kuneho",
  "item.minecraft.rabbit_stew": "Nilagang Kuneho",
  "item.minecraft.raiser_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Mang-aangat na Gayak sa Baluti",
  "item.minecraft.ravager_spawn_egg": "Panlikhaang Itlog ng Maninira",
  "item.minecraft.raw_copper": "Hilaw na Tanso",
  "item.minecraft.raw_gold": "Hilaw na Ginto",
  "item.minecraft.raw_iron": "Hilaw na Bakal",
  "item.minecraft.recovery_compass": "Bawing Paraluman",
  "item.minecraft.red_bundle": "Pulang Bungkos",
  "item.minecraft.red_dye": "Pulang Pangulay",
  "item.minecraft.red_harness": "Pulang Guwarnisyon",
  "item.minecraft.redstone": "Abo ng Redstone",
  "item.minecraft.resin_brick": "Tipak ng Laryong Dagta",
  "item.minecraft.resin_clump": "Kumpol ng Dagta",
  "item.minecraft.rib_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Patadyang na Gayak sa Baluti",
  "item.minecraft.rotten_flesh": "Bulok na Laman",
  "item.minecraft.saddle": "Sintadera",
  "item.minecraft.salmon": "Hilaw na Salmon",
  "item.minecraft.salmon_bucket": "Timba ng Salmon",
  "item.minecraft.salmon_spawn_egg": "Panlikhaang Itlog ng Salmon",
  "item.minecraft.scrape_pottery_sherd": "Palakol na Bibinga ng Palayok",
  "item.minecraft.scute": "Kaliskis",
  "item.minecraft.sentry_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Talibang Gayak sa Baluti",
  "item.minecraft.shaper_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Manghuhulmang Gayak sa Baluti",
  "item.minecraft.sheaf_pottery_shard": "Bungkos na Bubog ng Palayok",
  "item.minecraft.sheaf_pottery_sherd": "Bungkos na Bibinga ng Palayok",
  "item.minecraft.shears": "Gunting",
  "item.minecraft.sheep_spawn_egg": "Panlikhaang Itlog ng Tupa",
  "item.minecraft.shelter_pottery_shard": "Kanlungang Bubog ng Palayok",
  "item.minecraft.shelter_pottery_sherd": "Kanlungang Bibinga ng Palayok",
  "item.minecraft.shield": "Panangga",
  "item.minecraft.shield.black": "Itim na Panangga",
  "item.minecraft.shield.blue": "Bughaw na Panangga",
  "item.minecraft.shield.brown": "Kayumangging Panangga",
  "item.minecraft.shield.cyan": "Cyan na Panangga",
  "item.minecraft.shield.gray": "Abong Panangga",
  "item.minecraft.shield.green": "Lungtiang Panangga",
  "item.minecraft.shield.light_blue": "Langit na Panangga",
  "item.minecraft.shield.light_gray": "Pilak na Panangga",
  "item.minecraft.shield.lime": "Dayap na Panangga",
  "item.minecraft.shield.magenta": "Mahentang Panangga",
  "item.minecraft.shield.orange": "Bulantubig na Panangga",
  "item.minecraft.shield.pink": "Kalimbahing Panangga",
  "item.minecraft.shield.purple": "Habang Panangga",
  "item.minecraft.shield.red": "Pulang Panangga",
  "item.minecraft.shield.white": "Puting Panangga",
  "item.minecraft.shield.yellow": "Dilaw na Panangga",
  "item.minecraft.shulker_shell": "Kabibi ng Shulker",
  "item.minecraft.shulker_spawn_egg": "Panlikhaang Itlog ng Shulker",
  "item.minecraft.sign": "Karatula",
  "item.minecraft.silence_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Katahimikang Gayak sa Baluti",
  "item.minecraft.silverfish_spawn_egg": "Panlikhaang Itlog ng Pilakam-Uod",
  "item.minecraft.skeleton_horse_spawn_egg": "Panlikhaang Itlog ng Kabayong Kalansay",
  "item.minecraft.skeleton_spawn_egg": "Panlikhaang Itlog ng Kalansay",
  "item.minecraft.skull_banner_pattern": "Hulwaran ng Watawat",
  "item.minecraft.skull_banner_pattern.desc": "Selyo ng Bungo",
  "item.minecraft.skull_banner_pattern.new": "Hulwaran ng Watawat ng Tatak ng Bungo",
  "item.minecraft.skull_pottery_shard": "Bungong Bubog ng Palayok",
  "item.minecraft.skull_pottery_sherd": "Bungong Bibinga ng Palakol",
  "item.minecraft.slime_ball": "Bolang-lusak",
  "item.minecraft.slime_spawn_egg": "Panlikhaang Itlog ng Lusak",
  "item.minecraft.smithing_template": "Hulmahang Pampanday",
  "item.minecraft.smithing_template.applies_to": "Mailalagay sa:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Maglagay ng linggote o kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Baluti",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Magdagdag ng baluti",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Mga Linggote at Kristal",
  "item.minecraft.smithing_template.ingredients": "Mga sangkap:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Magdagdag ng Linggote ng Netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diyamanteng Kagamitan",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Magdagdag ng diyamanteng sapyaw, sandata, o kagamitan",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Linggote ng Netherita",
  "item.minecraft.smithing_template.upgrade": "Pagpapalakas: ",
  "item.minecraft.sniffer_spawn_egg": "Panlikhaang Itlog ng Palasinghot",
  "item.minecraft.snort_pottery_shard": "Singhot na Bubog ng Palayok",
  "item.minecraft.snort_pottery_sherd": "Singhot na Bibinga ng Palayok",
  "item.minecraft.snout_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Pangusong Gayak sa Baluti",
  "item.minecraft.snow_golem_spawn_egg": "Panlikhaang Itlog ng Niyebeng Golem",
  "item.minecraft.snowball": "Bolang-niyebe",
  "item.minecraft.spectral_arrow": "Palasong Pampaningning",
  "item.minecraft.spider_eye": "Mata ng Gagamba",
  "item.minecraft.spider_spawn_egg": "Panlikhaang Itlog ng Gagamba",
  "item.minecraft.spire_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Tukudlangit na Gayak sa Baluti",
  "item.minecraft.splash_potion": "Gayumang-hagis",
  "item.minecraft.splash_potion.effect.awkward": "Asiwang Gayumang-hagis",
  "item.minecraft.splash_potion.effect.empty": "Di-nagagawang Gayumang-hagis",
  "item.minecraft.splash_potion.effect.fire_resistance": "Gayumang-hagis na Katatagan sa Apoy",
  "item.minecraft.splash_potion.effect.harming": "Gayumang-hagis na Pampanakit",
  "item.minecraft.splash_potion.effect.healing": "Gayumang-hagis na Pampagaling",
  "item.minecraft.splash_potion.effect.infested": "Gayumang-hagis ng Pamumugad",
  "item.minecraft.splash_potion.effect.invisibility": "Gayumang-hagis na Malikmata",
  "item.minecraft.splash_potion.effect.leaping": "Gayuma ng Pagtalon",
  "item.minecraft.splash_potion.effect.levitation": "Gayumang-hagis na Pampalutang",
  "item.minecraft.splash_potion.effect.luck": "Gayumang-hagis ng Mapalad",
  "item.minecraft.splash_potion.effect.mundane": "Mababaw na Gayumang-hagis",
  "item.minecraft.splash_potion.effect.night_vision": "Gayumang-hagis na Pampalinaw-mata",
  "item.minecraft.splash_potion.effect.oozing": "Gayumang-hagis ng Pagnanana",
  "item.minecraft.splash_potion.effect.poison": "Gayumang-hagis na Pampalason",
  "item.minecraft.splash_potion.effect.regeneration": "Gayumang-hagis na Pampanumbalik",
  "item.minecraft.splash_potion.effect.slow_falling": "Gayumang-hagis na Marahang Pagbagsak",
  "item.minecraft.splash_potion.effect.slowness": "Gayumang-hagis na Pampabagal",
  "item.minecraft.splash_potion.effect.strength": "Gayumang-hagis na Pampalakas",
  "item.minecraft.splash_potion.effect.swiftness": "Gayumang-hagis na Pampabilis",
  "item.minecraft.splash_potion.effect.thick": "Malapot na Gayumang-hagis",
  "item.minecraft.splash_potion.effect.turtle_master": "Gayumang-hagis ng Dalubhasang Pawikan",
  "item.minecraft.splash_potion.effect.water": "Boteng-hagis ng Tubig",
  "item.minecraft.splash_potion.effect.water_breathing": "Gayumang-hagis ng Paghinga sa Tubig",
  "item.minecraft.splash_potion.effect.weakness": "Gayumang-hagis na Pampahina",
  "item.minecraft.splash_potion.effect.weaving": "Gayumang-hagis ng Paghabi",
  "item.minecraft.splash_potion.effect.wind_charged": "Gayumang-hagis ng Pagbuhawi",
  "item.minecraft.spruce_boat": "Sahing na Bangka",
  "item.minecraft.spruce_chest_boat": "Sahing na Bangkang may Kaban",
  "item.minecraft.spyglass": "Anteoho",
  "item.minecraft.squid_spawn_egg": "Panlikhaang Itlog ng Pusit",
  "item.minecraft.stick": "Tungkod",
  "item.minecraft.stone_axe": "Batong Palakol",
  "item.minecraft.stone_hoe": "Batong Asarol",
  "item.minecraft.stone_pickaxe": "Batong Patik",
  "item.minecraft.stone_shovel": "Batong Pala",
  "item.minecraft.stone_spear": "Batong Sibat",
  "item.minecraft.stone_sword": "Batong Tabak",
  "item.minecraft.stray_spawn_egg": "Panlikhaang Itlog ng Ligaw",
  "item.minecraft.strider_spawn_egg": "Panlikhaang Itlog ng Palahakbang",
  "item.minecraft.string": "Tali",
  "item.minecraft.sugar": "Asukal",
  "item.minecraft.suspicious_stew": "Kahina-hinalang Nilaga",
  "item.minecraft.sweet_berries": "Tamising Pagla",
  "item.minecraft.tadpole_bucket": "Timba ng Butete",
  "item.minecraft.tadpole_spawn_egg": "Panlikhaang Itlog ng Butete",
  "item.minecraft.tide_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Paalong Gayak sa Baluti",
  "item.minecraft.tipped_arrow": "Sinawsaw na Palaso",
  "item.minecraft.tipped_arrow.effect.awkward": "Sinawsaw na Palaso",
  "item.minecraft.tipped_arrow.effect.empty": "Di-nagagawang Sinawsaw na Palaso",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Palaso ng Katatagan sa Apoy",
  "item.minecraft.tipped_arrow.effect.harming": "Palasong Pampanakit",
  "item.minecraft.tipped_arrow.effect.healing": "Palasong Pampagaling",
  "item.minecraft.tipped_arrow.effect.infested": "Palaso ng Pamumugad",
  "item.minecraft.tipped_arrow.effect.invisibility": "Palaso ng Malikmata",
  "item.minecraft.tipped_arrow.effect.leaping": "Palaso ng Pagtalon",
  "item.minecraft.tipped_arrow.effect.levitation": "Palasong Pampalutang",
  "item.minecraft.tipped_arrow.effect.luck": "Palasong Pampanigo",
  "item.minecraft.tipped_arrow.effect.mundane": "Sinawsaw na Palaso",
  "item.minecraft.tipped_arrow.effect.night_vision": "Palasong Pampalinaw-mata",
  "item.minecraft.tipped_arrow.effect.oozing": "Palaso ng Pagnanana",
  "item.minecraft.tipped_arrow.effect.poison": "Palasong Pampalason",
  "item.minecraft.tipped_arrow.effect.regeneration": "Palasong Pampanumbalik",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Palaso ng Marahang Pagbagsak",
  "item.minecraft.tipped_arrow.effect.slowness": "Palasong Pampabagal",
  "item.minecraft.tipped_arrow.effect.strength": "Palasong Pampalakas",
  "item.minecraft.tipped_arrow.effect.swiftness": "Palasong Pampabilis",
  "item.minecraft.tipped_arrow.effect.thick": "Sinawsaw na Palaso",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Palaso ng Dalubhasang Pawikan",
  "item.minecraft.tipped_arrow.effect.water": "Palaso ng Hagis",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Palaso ng Paghinga sa Tubig",
  "item.minecraft.tipped_arrow.effect.weakness": "Palasong Pampahina",
  "item.minecraft.tipped_arrow.effect.weaving": "Palaso ng Paghabi",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Palaso ng Pagbuhawi",
  "item.minecraft.tnt_minecart": "Karitelang may TNT",
  "item.minecraft.torchflower_seeds": "Buto ng Sulumbulak",
  "item.minecraft.totem_of_undying": "Agimat ng Walang Kamatayan",
  "item.minecraft.trader_llama_spawn_egg": "Panlikhaang Itlog ng Liyama ng Mangangalakal",
  "item.minecraft.trial_key": "Susi ng Pagsubok",
  "item.minecraft.trident": "Salapang",
  "item.minecraft.tropical_fish": "Isdang Tropiko",
  "item.minecraft.tropical_fish_bucket": "Timba ng Isdang Tropiko",
  "item.minecraft.tropical_fish_spawn_egg": "Panlikhaang Itlog ng Isdang Tropiko",
  "item.minecraft.turtle_helmet": "Talukab ng Pawikan",
  "item.minecraft.turtle_scute": "Kaliskis ng Pawikan",
  "item.minecraft.turtle_spawn_egg": "Panlikhaang Itlog ng Pawikan",
  "item.minecraft.vex_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Gugulong Gayak sa Baluti",
  "item.minecraft.vex_spawn_egg": "Panlikhaang Itlog ng Gugulo",
  "item.minecraft.villager_spawn_egg": "Panlikhaang Itlog ng Taganayon",
  "item.minecraft.vindicator_spawn_egg": "Panlikhaang Itlog ng Tatanggol",
  "item.minecraft.wandering_trader_spawn_egg": "Panlikhaang Itlog ng Lagalag na Mangangalakal",
  "item.minecraft.ward_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Mala-wardeng Gayak sa Baluti",
  "item.minecraft.warden_spawn_egg": "Panlikhaang Itlog ng Malahakan",
  "item.minecraft.warped_fungus_on_a_stick": "Kiwal na Kabuti sa Tungkod",
  "item.minecraft.water_bucket": "Timba ng Tubig",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Tagahanap ng Daang Gayak sa Baluti",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Buto ng Trigo",
  "item.minecraft.white_bundle": "Puting Bungkos",
  "item.minecraft.white_dye": "Puting Pangulay",
  "item.minecraft.white_harness": "Puting Guwarnisyon",
  "item.minecraft.wild_armor_trim_smithing_template": "Hulmahang Pampanday",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Kagubatang Gayak sa Baluti",
  "item.minecraft.wind_charge": "Bolang-buhawi",
  "item.minecraft.witch_spawn_egg": "Panlikhaang Itlog ng Mangkukulam",
  "item.minecraft.wither_skeleton_spawn_egg": "Panlikhaang Itlog ng Wither na Kalansay",
  "item.minecraft.wither_spawn_egg": "Panlikhaang Itlog ng Wither",
  "item.minecraft.wolf_armor": "Panlobong Baluti",
  "item.minecraft.wolf_spawn_egg": "Panlikhaang Itlog ng Lobo",
  "item.minecraft.wooden_axe": "Kahoy na Palakol",
  "item.minecraft.wooden_hoe": "Kahoy na Asarol",
  "item.minecraft.wooden_pickaxe": "Kahoy na Patik",
  "item.minecraft.wooden_shovel": "Kahoy na Pala",
  "item.minecraft.wooden_spear": "Kahoy na Sibat",
  "item.minecraft.wooden_sword": "Kahoy na Tabak",
  "item.minecraft.writable_book": "Aklat at Pluma",
  "item.minecraft.written_book": "Sinulatang Aklat",
  "item.minecraft.yellow_bundle": "Dilaw na Bungkos",
  "item.minecraft.yellow_dye": "Dilaw na Pangulay",
  "item.minecraft.yellow_harness": "Dilaw na Guwarnisyon",
  "item.minecraft.zoglin_spawn_egg": "Panlikhaang Itlog ng Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Panlikhaang Itlog ng Kabayong Maranhig",
  "item.minecraft.zombie_nautilus_spawn_egg": "Panlikhaang Itlog ng Lagang Maranhig",
  "item.minecraft.zombie_spawn_egg": "Panlikhaang Itlog ng Maranhig",
  "item.minecraft.zombie_villager_spawn_egg": "Panlikhaang Itlog ng Taganayong Maranhig",
  "item.minecraft.zombified_piglin_spawn_egg": "Panlikhaang Itlog ng Pigling Maranhig"
}
export const tl_ph = items; 
